import {
  StateData,
  DistrictData,
  DISCOMData,
  CircleData,
  Alarm,
  AlarmSeverity,
  ServiceTicket,
  TicketStatus,
  RMSDevice,
  PlantStatus,
  ConsumerPlant,
  VendorPlant,
  GenerationDataPoint,
  MonthlyDataPoint,
  HourlyDataPoint,
  VoltageDataPoint,
  FaultDistribution,
  BillingCycle,
  FeederData,
  VarianceAlert,
  CommandLog,
} from '../types';

// ─── National KPIs ───────────────────────────────────────────────────────────
export const nationalKPIs = {
  totalPlants: 28450,
  newPlantsMonth: 342,
  installedCapacityGWp: 9.1,
  statesCount: 28,
  todayGenerationGWh: 36,
  generationChangePercent: 6.2,
  activePlants: 24318,
  activePercent: 85.4,
  offlineFault: 4132,
  offlinePercent: 14.6,
  avgPR: 74.3,
  avgCUF: 18.6,
  co2OffsetMT: 1.24,
  monthlyGWh: 892,
  lifetimeTWh: 4.7,
  peakGW: 7.8,
  avgSpecificYield: 3.95,
  statesActive: 28,
  discoomsOnboarded: 64,
  districtsCovered: 312,
  feedersMonitored: 4820,
  activeAlarms: 1247,
  criticalAlarms: 183,
  warningAlarms: 641,
  infoAlarms: 423,
  resolvedToday: 89,
  mttrHours: 4.2,
  dataTransmissionPercent: 97.3,
  mnreComplianceScore: 88,
  outdatedFirmware: 342,
  certsExpiring: 67,
  platformUptime: 99.94,
};

// ─── States ───────────────────────────────────────────────────────────────────
export const statesData: StateData[] = [
  {
    id: 'GJ',
    name: 'Gujarat',
    plants: 6240,
    capacityGWp: 2.1,
    generationGWh: 9.84,
    prPercent: 78.2,
    cufPercent: 21.4,
    activePercent: 91.0,
    alarms: 142,
    momTrend: 3.2,
    status: 'online',
  },
  {
    id: 'TN',
    name: 'Tamil Nadu',
    plants: 5120,
    capacityGWp: 1.8,
    generationGWh: 8.12,
    prPercent: 76.5,
    cufPercent: 19.8,
    activePercent: 89.0,
    alarms: 98,
    momTrend: 1.8,
    status: 'online',
  },
  {
    id: 'RJ',
    name: 'Rajasthan',
    plants: 4380,
    capacityGWp: 1.5,
    generationGWh: 6.54,
    prPercent: 75.1,
    cufPercent: 20.2,
    activePercent: 87.0,
    alarms: 211,
    momTrend: -1.2,
    status: 'warning',
  },
  {
    id: 'MH',
    name: 'Maharashtra',
    plants: 3960,
    capacityGWp: 1.3,
    generationGWh: 5.43,
    prPercent: 72.8,
    cufPercent: 18.1,
    activePercent: 84.0,
    alarms: 187,
    momTrend: 0.5,
    status: 'online',
  },
  {
    id: 'KA',
    name: 'Karnataka',
    plants: 3240,
    capacityGWp: 1.1,
    generationGWh: 4.21,
    prPercent: 74.3,
    cufPercent: 17.6,
    activePercent: 86.0,
    alarms: 134,
    momTrend: 2.1,
    status: 'online',
  },
  {
    id: 'MP',
    name: 'Madhya Pradesh',
    plants: 2840,
    capacityGWp: 0.9,
    generationGWh: 3.18,
    prPercent: 67.4,
    cufPercent: 16.3,
    activePercent: 78.0,
    alarms: 298,
    momTrend: -3.4,
    status: 'warning',
  },
  {
    id: 'KL',
    name: 'Kerala',
    plants: 1820,
    capacityGWp: 0.6,
    generationGWh: 2.83,
    prPercent: 70.1,
    cufPercent: 15.8,
    activePercent: 82.0,
    alarms: 76,
    momTrend: 0.9,
    status: 'online',
  },
  {
    id: 'UP',
    name: 'Uttar Pradesh',
    plants: 850,
    capacityGWp: 0.3,
    generationGWh: 1.11,
    prPercent: 65.2,
    cufPercent: 14.1,
    activePercent: 74.0,
    alarms: 101,
    momTrend: -2.1,
    status: 'warning',
  },
];

// ─── DISCOMs for Gujarat ──────────────────────────────────────────────────────
export const gujaratDISCOMs: DISCOMData[] = [
  {
    id: 'PGVCL',
    name: 'PGVCL',
    state: 'Gujarat',
    plants: 2840,
    capacityGWp: 0.96,
    generationGWh: 4.48,
    prPercent: 79.1,
    activePercent: 92.0,
    alarms: 58,
  },
  {
    id: 'MGVCL',
    name: 'MGVCL',
    state: 'Gujarat',
    plants: 1680,
    capacityGWp: 0.56,
    generationGWh: 2.64,
    prPercent: 77.8,
    activePercent: 90.0,
    alarms: 41,
  },
  {
    id: 'DGVCL',
    name: 'DGVCL',
    state: 'Gujarat',
    plants: 980,
    capacityGWp: 0.33,
    generationGWh: 1.54,
    prPercent: 76.2,
    activePercent: 89.5,
    alarms: 28,
  },
  {
    id: 'UGVCL',
    name: 'UGVCL',
    state: 'Gujarat',
    plants: 740,
    capacityGWp: 0.25,
    generationGWh: 1.18,
    prPercent: 78.5,
    activePercent: 91.2,
    alarms: 15,
  },
];

// ─── Gujarat Districts ────────────────────────────────────────────────────────
export const gujaratDistricts: DistrictData[] = [
  /* ── Top 5 (existing) ─────────────────────────────────────────────── */
  { id: 'AMD', name: 'Ahmedabad',    plants: 1420, generationGWh: 2.81, prPercent: 78.4, status: 'online'  },
  { id: 'SUR', name: 'Surat',        plants:  980, generationGWh: 1.94, prPercent: 76.9, status: 'online'  },
  { id: 'VDR', name: 'Vadodara',     plants:  760, generationGWh: 1.51, prPercent: 77.2, status: 'online'  },
  { id: 'RJK', name: 'Rajkot',       plants:  620, generationGWh: 1.22, prPercent: 79.8, status: 'online'  },
  { id: 'JND', name: 'Junagadh',     plants:  480, generationGWh: 0.91, prPercent: 74.1, status: 'warning' },
  /* ── Remaining Gujarat districts ──────────────────────────────────── */
  { id: 'BHR', name: 'Bharuch',      plants:  420, generationGWh: 0.84, prPercent: 77.9, status: 'online'  },
  { id: 'KTC', name: 'Kachchh',      plants:  380, generationGWh: 0.76, prPercent: 76.3, status: 'online'  },
  { id: 'BHV', name: 'Bhavnagar',    plants:  355, generationGWh: 0.71, prPercent: 76.8, status: 'online'  },
  { id: 'GND', name: 'Gandhinagar',  plants:  340, generationGWh: 0.68, prPercent: 77.5, status: 'online'  },
  { id: 'JMN', name: 'Jamnagar',     plants:  295, generationGWh: 0.59, prPercent: 75.6, status: 'online'  },
  { id: 'JMG', name: 'Jamnagar',     plants:  280, generationGWh: 0.56, prPercent: 74.9, status: 'online'  },
  { id: 'NVS', name: 'Navsari',      plants:  265, generationGWh: 0.53, prPercent: 75.1, status: 'online'  },
  { id: 'BNK', name: 'Banas Kantha', plants:  260, generationGWh: 0.52, prPercent: 72.4, status: 'warning' },
  { id: 'AMR', name: 'Amreli',       plants:  245, generationGWh: 0.49, prPercent: 73.5, status: 'online'  },
  { id: 'SRN', name: 'Surendranagar',plants:  230, generationGWh: 0.46, prPercent: 72.9, status: 'online'  },
  { id: 'VLS', name: 'Valsad',       plants:  220, generationGWh: 0.44, prPercent: 74.5, status: 'online'  },
  { id: 'AND', name: 'Anand',        plants:  390, generationGWh: 0.78, prPercent: 76.1, status: 'online'  },
  { id: 'PTN', name: 'Patan',        plants:  210, generationGWh: 0.42, prPercent: 73.9, status: 'online'  },
  { id: 'PRB', name: 'Porbandar',    plants:  180, generationGWh: 0.36, prPercent: 74.2, status: 'online'  },
  { id: 'PMH', name: 'Panch Mahals', plants:  175, generationGWh: 0.35, prPercent: 71.2, status: 'online'  },
  { id: 'SBK', name: 'Sabar Kantha', plants:  195, generationGWh: 0.39, prPercent: 71.8, status: 'online'  },
  { id: 'KHD', name: 'Kheda',        plants:  310, generationGWh: 0.62, prPercent: 75.3, status: 'online'  },
  { id: 'MHN', name: 'Mahesana',     plants:  285, generationGWh: 0.57, prPercent: 74.8, status: 'online'  },
  { id: 'NRM', name: 'Narmada',      plants:  135, generationGWh: 0.27, prPercent: 70.1, status: 'online'  },
  { id: 'DHD', name: 'Dahod',        plants:  145, generationGWh: 0.29, prPercent: 69.8, status: 'warning' },
  { id: 'TAP', name: 'Tapi',         plants:  110, generationGWh: 0.22, prPercent: 68.9, status: 'online'  },
  { id: 'DNG', name: 'The Dangs',    plants:   45, generationGWh: 0.09, prPercent: 67.2, status: 'warning' },
];

// ─── PGVCL Circles ────────────────────────────────────────────────────────────
export const pgvclCircles: CircleData[] = [
  { id: 'AMD-C', name: 'Ahmedabad Circle', plants: 920, generationMWh: 1824, prPercent: 79.4, activePercent: 93.2, alarms: 18, mttrHours: 3.8 },
  { id: 'GND-C', name: 'Gandhinagar Circle', plants: 640, generationMWh: 1267, prPercent: 78.9, activePercent: 91.8, alarms: 12, mttrHours: 4.1 },
  { id: 'ANK-C', name: 'Ankleshwar Circle', plants: 520, generationMWh: 1031, prPercent: 80.1, activePercent: 94.0, alarms: 9, mttrHours: 3.2 },
  { id: 'KDA-C', name: 'Kheda Circle', plants: 340, generationMWh: 673, prPercent: 77.6, activePercent: 90.1, alarms: 14, mttrHours: 5.2 },
  { id: 'MEH-C', name: 'Mehsana Circle', plants: 420, generationMWh: 830, prPercent: 78.2, activePercent: 92.5, alarms: 5, mttrHours: 3.6 },
];

// ─── National Generation (15 days) ───────────────────────────────────────────
export const nationalDailyGeneration: GenerationDataPoint[] = [
  { label: '13 Apr', value: 33.2 },
  { label: '14 Apr', value: 34.8 },
  { label: '15 Apr', value: 31.5 },
  { label: '16 Apr', value: 35.1 },
  { label: '17 Apr', value: 36.4 },
  { label: '18 Apr', value: 34.9 },
  { label: '19 Apr', value: 32.8 },
  { label: '20 Apr', value: 37.2 },
  { label: '21 Apr', value: 35.6 },
  { label: '22 Apr', value: 38.1 },
  { label: '23 Apr', value: 36.9 },
  { label: '24 Apr', value: 35.4 },
  { label: '25 Apr', value: 37.8 },
  { label: '26 Apr', value: 33.9 },
  { label: '27 Apr', value: 36.0, highlighted: true },
];

export const nationalMonthlyGeneration: GenerationDataPoint[] = [
  { label: 'Nov', value: 718 },
  { label: 'Dec', value: 652 },
  { label: 'Jan', value: 741 },
  { label: 'Feb', value: 798 },
  { label: 'Mar', value: 864 },
  { label: 'Apr', value: 892, highlighted: true },
];

export const nationalHourlyGeneration: GenerationDataPoint[] = [
  { label: '6AM', value: 2.1 },
  { label: '7AM', value: 8.4 },
  { label: '8AM', value: 18.6 },
  { label: '9AM', value: 28.3 },
  { label: '10AM', value: 34.7 },
  { label: '11AM', value: 38.9 },
  { label: '12PM', value: 40.2, highlighted: true },
  { label: '1PM', value: 39.1 },
  { label: '2PM', value: 36.8 },
  { label: '3PM', value: 31.4 },
  { label: '4PM', value: 22.6 },
  { label: '5PM', value: 12.1 },
  { label: '6PM', value: 3.4 },
];

// ─── State (Gujarat) Generation ───────────────────────────────────────────────
export const gujaratDailyGeneration: GenerationDataPoint[] = [
  { label: '13 Apr', value: 8.92 },
  { label: '14 Apr', value: 9.34 },
  { label: '15 Apr', value: 8.41 },
  { label: '16 Apr', value: 9.18 },
  { label: '17 Apr', value: 9.67 },
  { label: '18 Apr', value: 9.22 },
  { label: '19 Apr', value: 8.78 },
  { label: '20 Apr', value: 9.91 },
  { label: '21 Apr', value: 9.45 },
  { label: '22 Apr', value: 10.12 },
  { label: '23 Apr', value: 9.83 },
  { label: '24 Apr', value: 9.38 },
  { label: '25 Apr', value: 10.04 },
  { label: '26 Apr', value: 8.96 },
  { label: '27 Apr', value: 9.84, highlighted: true },
];

export const gujaratPRTrend = [
  { month: 'Nov', value: 74.1 },
  { month: 'Dec', value: 73.8 },
  { month: 'Jan', value: 75.2 },
  { month: 'Feb', value: 76.4 },
  { month: 'Mar', value: 77.1 },
  { month: 'Apr', value: 78.2 },
];

export const gujaratMonthlyGeneration: GenerationDataPoint[] = [
  { label: 'Nov', value: 218.4 },
  { label: 'Dec', value: 204.6 },
  { label: 'Jan', value: 226.8 },
  { label: 'Feb', value: 236.1 },
  { label: 'Mar', value: 248.9 },
  { label: 'Apr', value: 241.0, highlighted: true },
];

export const gujaratHourlyGeneration: GenerationDataPoint[] = [
  { label: '6AM',  value: 128 },
  { label: '7AM',  value: 312 },
  { label: '8AM',  value: 548 },
  { label: '9AM',  value: 742 },
  { label: '10AM', value: 882 },
  { label: '11AM', value: 1024 },
  { label: '12PM', value: 1124, highlighted: true },
  { label: '1PM',  value: 1086 },
  { label: '2PM',  value: 984 },
  { label: '3PM',  value: 824 },
  { label: '4PM',  value: 612 },
  { label: '5PM',  value: 348 },
  { label: '6PM',  value: 104 },
];

// ─── State generation by DISCOM ───────────────────────────────────────────────
export const discomGenerationBars = [
  { label: 'PGVCL', value: 4.48 },
  { label: 'MGVCL', value: 2.64 },
  { label: 'DGVCL', value: 1.54 },
  { label: 'UGVCL', value: 1.18 },
];

// ─── Top 5 Performing Plants ──────────────────────────────────────────────────
export const top5Plants = [
  { id: 'GJ-1024', state: 'Gujarat', kwhToday: 48.2, pr: 88.4 },
  { id: 'TN-0312', state: 'Tamil Nadu', kwhToday: 46.9, pr: 87.1 },
  { id: 'RJ-2201', state: 'Rajasthan', kwhToday: 45.8, pr: 86.3 },
  { id: 'GJ-0891', state: 'Gujarat', kwhToday: 44.6, pr: 85.9 },
  { id: 'KA-0554', state: 'Karnataka', kwhToday: 43.1, pr: 85.2 },
];

// ─── Alarms ───────────────────────────────────────────────────────────────────
export const nationalAlarms: Alarm[] = [
  {
    id: 'ALM-8821',
    severity: AlarmSeverity.CRITICAL,
    description: 'Grid voltage out of range — inverter tripped',
    parameter: 'ACVOLT',
    plantId: 'RJ-2201',
    state: 'Rajasthan',
    timestamp: '2026-04-28T10:42:00',
    duration: '1h 18m',
    status: 'ACTIVE',
    faultType: 'Voltage FT1',
  },
  {
    id: 'ALM-8820',
    severity: AlarmSeverity.WARNING,
    description: 'MPPT 2 power consistently lower than MPPT 1',
    parameter: 'DCKW2',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-04-26T08:15:00',
    duration: '2 days',
    status: 'ACTIVE',
    faultType: 'Other',
  },
  {
    id: 'ALM-8819',
    severity: AlarmSeverity.INFO,
    description: 'Communication loss — datalogger offline',
    parameter: 'COMMS',
    plantId: 'MP-1102',
    state: 'Madhya Pradesh',
    timestamp: '2026-04-28T09:30:00',
    duration: '2h 30m',
    status: 'ACTIVE',
    faultType: 'Comms',
  },
  {
    id: 'ALM-8818',
    severity: AlarmSeverity.CRITICAL,
    description: 'Inverter over-temperature shutdown',
    parameter: 'INVTEMP',
    plantId: 'MH-0934',
    state: 'Maharashtra',
    timestamp: '2026-04-28T11:05:00',
    duration: '55m',
    status: 'ACTIVE',
    faultType: 'Temperature FT4',
  },
  {
    id: 'ALM-8817',
    severity: AlarmSeverity.WARNING,
    description: 'Grid frequency deviation detected',
    parameter: 'ACFREQ',
    plantId: 'TN-0312',
    state: 'Tamil Nadu',
    timestamp: '2026-04-28T07:48:00',
    duration: '4h 12m',
    status: 'ACTIVE',
    faultType: 'Frequency FT2',
  },
  {
    id: 'ALM-8812',
    severity: AlarmSeverity.INFO,
    description: 'Communication restored after 3h offline',
    parameter: 'COMMS',
    plantId: 'KA-0554',
    state: 'Karnataka',
    timestamp: '2026-04-27T14:22:00',
    duration: '3h 4m',
    status: 'RESOLVED',
    faultType: 'Comms',
  },
];

export const consumerAlarms: Alarm[] = [
  {
    id: 'ALM-8820',
    severity: AlarmSeverity.WARNING,
    description: 'MPPT 2 power consistently lower than MPPT 1 — possible soiling or shading',
    parameter: 'DCKW2',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-04-26T08:15:00',
    duration: '2 days',
    status: 'ACTIVE',
    faultType: 'MPPT',
  },
  {
    id: 'ALM-8754',
    severity: AlarmSeverity.INFO,
    description: 'Communication loss — datalogger offline for 45 minutes',
    parameter: 'COMMS',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-04-25T14:10:00',
    duration: '45m',
    status: 'RESOLVED',
    faultType: 'Comms',
  },
  {
    id: 'ALM-8698',
    severity: AlarmSeverity.WARNING,
    description: 'Grid voltage high — 248V sustained for 12 minutes',
    parameter: 'ACVOLT',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-04-18T11:32:00',
    duration: '12m',
    status: 'RESOLVED',
    faultType: 'Voltage FT1',
  },
  {
    id: 'ALM-8621',
    severity: AlarmSeverity.INFO,
    description: 'Inverter restart after firmware update',
    parameter: 'INV',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-03-15T09:00:00',
    duration: '4m',
    status: 'RESOLVED',
    faultType: 'Comms',
  },
  {
    id: 'ALM-8512',
    severity: AlarmSeverity.WARNING,
    description: 'DC string 1 undervoltage — possible shading event',
    parameter: 'DCVOLT1',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-02-22T13:45:00',
    duration: '1h 22m',
    status: 'RESOLVED',
    faultType: 'Voltage FT1',
  },
  {
    id: 'ALM-8401',
    severity: AlarmSeverity.INFO,
    description: 'Communication loss during power outage',
    parameter: 'COMMS',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2025-09-10T16:20:00',
    duration: '2h 15m',
    status: 'RESOLVED',
    faultType: 'Comms',
  },
];

// ─── Fault Distribution ────────────────────────────────────────────────────────
export const faultDistribution: FaultDistribution[] = [
  { name: 'Comms', value: 43, color: '#2472C8' },
  { name: 'Voltage FT1', value: 22, color: '#B52020' },
  { name: 'Temperature FT4', value: 14, color: '#C25A0A' },
  { name: 'Frequency FT2', value: 11, color: '#5B3FA6' },
  { name: 'Other', value: 10, color: '#0D6B5A' },
];

// ─── Compliance ───────────────────────────────────────────────────────────────
export const stateCompliance = [
  { state: 'Gujarat', percent: 96.4, status: 'green' },
  { state: 'Tamil Nadu', percent: 94.1, status: 'green' },
  { state: 'Rajasthan', percent: 89.3, status: 'green' },
  { state: 'Maharashtra', percent: 87.6, status: 'green' },
  { state: 'Karnataka', percent: 83.2, status: 'amber' },
  { state: 'Madhya Pradesh', percent: 71.4, status: 'amber' },
  { state: 'Kerala', percent: 67.8, status: 'red' },
];

// ─── Consumer Plant GJ-0482 ───────────────────────────────────────────────────
export const consumerPlant: ConsumerPlant = {
  id: 'GJ-0482',
  consumerName: 'Amitbhai Patel',
  address: 'Plot 14, Satellite Road, Ahmedabad, Gujarat 380015',
  capacityKWp: 6,
  inverterBrand: 'Sofar',
  discom: 'PGVCL',
  state: 'Gujarat',
  district: 'Ahmedabad',
  commissionDate: '2025-01-10',
  status: PlantStatus.ONLINE,
  livePowerKW: 4.2,
  todayKWh: 14.55,
  todaySavings: 109,
  prPercent: 76.4,
  lifetimeKWh: 3842,
  lifetimeSavings: 28815,
  co2OffsetMT: 2.73,
  healthScore: 82,
  plantAvailabilityPct: 96.8,
  specificYieldMonthly: 4.18,
  electrical: {
    dcVoltage1: 330,
    dcCurrent1: 12.4,
    dcPower1: 4.09,
    dcVoltage2: 318,
    dcCurrent2: 11.8,
    dcPower2: 3.75,
    acVoltage: 241,
    acCurrent: 17.4,
    frequency: 49.98,
    powerFactor: 0.97,
    reactivePower: 0.62,
    apparentPower: 4.33,
    inverterTemp: 58,
    inverterStatus: 'ON',
    onTimeHours: 8.4,
    activePower: 4.2,
  },
  prNeighbours: [
    { label: 'My plant', value: 76.4, isMe: true },
    { label: 'Pincode avg 380015', value: 72.1, isMe: false },
    { label: 'District avg Ahmedabad', value: 70.3, isMe: false },
    { label: 'State avg Gujarat', value: 74.2, isMe: false },
  ],
};

// ─── Consumer power curve ─────────────────────────────────────────────────────
export const consumerPowerCurve: HourlyDataPoint[] = [
  { time: '6AM', power: 0.1 },
  { time: '6:30', power: 0.4 },
  { time: '7AM', power: 0.9 },
  { time: '7:30', power: 1.4 },
  { time: '8AM', power: 1.9 },
  { time: '8:30', power: 2.5 },
  { time: '9AM', power: 3.1 },
  { time: '9:30', power: 3.6 },
  { time: '10AM', power: 4.0 },
  { time: '10:30', power: 4.4 },
  { time: '11AM', power: 4.7 },
  { time: '11:30', power: 4.9 },
  { time: '12PM', power: 5.1 },
  { time: '12:30', power: 5.0 },
  { time: '1PM', power: 4.8 },
  { time: '1:30', power: 4.5 },
  { time: '2PM', power: 4.2 },
  { time: '2:30', power: 3.8 },
  { time: '3PM', power: 3.2 },
  { time: '3:30', power: 2.6 },
  { time: '4PM', power: 2.0 },
  { time: '4:30', power: 1.3 },
  { time: '5PM', power: 0.7 },
  { time: '5:30', power: 0.3 },
  { time: '6PM', power: 0.0 },
];

// ─── AC Voltage trend ─────────────────────────────────────────────────────────
export const acVoltageTrend: VoltageDataPoint[] = [
  { time: '6AM', voltage: 239 },
  { time: '7AM', voltage: 240 },
  { time: '8AM', voltage: 241 },
  { time: '9AM', voltage: 242 },
  { time: '10AM', voltage: 243 },
  { time: '11AM', voltage: 244 },
  { time: '12PM', voltage: 243 },
  { time: '1PM', voltage: 242 },
  { time: '2PM', voltage: 241 },
  { time: '3PM', voltage: 240 },
  { time: '4PM', voltage: 241 },
  { time: '5PM', voltage: 240 },
  { time: '6PM', voltage: 239 },
];

// ─── Monthly generation & export ──────────────────────────────────────────────
export const consumerMonthlyData: MonthlyDataPoint[] = [
  { month: 'Nov', generated: 412, exported: 198 },
  { month: 'Dec', generated: 374, exported: 162 },
  { month: 'Jan', generated: 421, exported: 207 },
  { month: 'Feb', generated: 498, exported: 241 },
  { month: 'Mar', generated: 563, exported: 278 },
  { month: 'Apr', generated: 574, exported: 312 },
];

// ─── Billing cycles ───────────────────────────────────────────────────────────
export const billingCycles: BillingCycle[] = [
  { month: 'Apr 2026', exportKWh: 312, importKWh: 148, estimatedCredit: 1716 },
  { month: 'Mar 2026', exportKWh: 278, importKWh: 162, estimatedCredit: 1529 },
  { month: 'Feb 2026', exportKWh: 241, importKWh: 179, estimatedCredit: 1326 },
];

// ─── Service Tickets ──────────────────────────────────────────────────────────
export const consumerTickets: ServiceTicket[] = [
  {
    id: 'TKT-2024-0481',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Inverter / MPPT fault',
    description: 'MPPT 2 output is consistently 8% lower than MPPT 1. Possible soiling or partial shading on string 2. Request site inspection.',
    raisedDate: '2026-04-26',
    assignedTo: 'Ravi Kumar',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.OPEN,
    priority: 'NORMAL',
  },
  {
    id: 'TKT-2024-0398',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Communication / Datalogger issue',
    description: 'Datalogger went offline intermittently for 45 minutes.',
    raisedDate: '2026-04-25',
    assignedTo: 'Priya Shah',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.RESOLVED,
    resolutionTime: '0.5 days',
    priority: 'LOW',
  },
  {
    id: 'TKT-2024-0302',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Grid voltage issue',
    description: 'Inverter reported high grid voltage causing brief shutdown.',
    raisedDate: '2026-04-18',
    assignedTo: 'Ravi Kumar',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.RESOLVED,
    resolutionTime: '1.2 days',
    priority: 'NORMAL',
  },
  {
    id: 'TKT-2024-0187',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Panel cleaning request',
    description: 'Requesting scheduled cleaning for optimal performance.',
    raisedDate: '2026-02-10',
    assignedTo: 'Suresh Patel',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.RESOLVED,
    resolutionTime: '3.0 days',
    priority: 'LOW',
  },
];

// ─── RMS Devices ──────────────────────────────────────────────────────────────
export const rmsDevices: RMSDevice[] = [
  {
    imei: '354678901234567',
    plantId: 'GJ-0482',
    status: PlantStatus.ONLINE,
    firmwareVersion: '2.4.1',
    certExpiry: '2026-05-15',
    lastSeen: '2026-04-28T12:00:00',
    daysToExpiry: 17,
  },
  {
    imei: '354678901234568',
    plantId: 'GJ-1024',
    status: PlantStatus.ONLINE,
    firmwareVersion: '2.3.8',
    certExpiry: '2026-06-30',
    lastSeen: '2026-04-28T11:55:00',
    daysToExpiry: 63,
  },
  {
    imei: '354678901234569',
    plantId: 'RJ-2201',
    status: PlantStatus.OFFLINE,
    firmwareVersion: '2.2.1',
    certExpiry: '2026-04-10',
    lastSeen: '2026-04-27T08:30:00',
    daysToExpiry: -18,
  },
  {
    imei: '354678901234570',
    plantId: 'TN-0312',
    status: PlantStatus.ONLINE,
    firmwareVersion: '2.4.1',
    certExpiry: '2026-12-01',
    lastSeen: '2026-04-28T11:58:00',
    daysToExpiry: 217,
  },
  {
    imei: '354678901234571',
    plantId: 'MP-1102',
    status: PlantStatus.WARNING,
    firmwareVersion: '2.1.4',
    certExpiry: '2026-05-08',
    lastSeen: '2026-04-28T09:45:00',
    daysToExpiry: 10,
  },
];

// ─── Vendor Plants (summary) ──────────────────────────────────────────────────
const vendorStates    = ['Gujarat', 'Tamil Nadu', 'Rajasthan', 'Maharashtra', 'Karnataka'];
const vendorDistricts = ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Junagadh'];
const vendorTowns     = ['Bavla', 'Dholka', 'Sanand', 'Viramgam', 'Mansa'];
const vendorVillages  = ['Vavol', 'Tragad', 'Bopal', 'Ghuma', 'Sarkhej'];
const vendorPincodes  = ['382220', '382481', '382210', '382150', '382845'];
const vendorCircles   = ['Ahmedabad', 'Gandhinagar', 'Ankleshwar', 'Kheda', 'Mehsana'];
const vendorDivisions = ['Division East', 'Division West', 'Division North', 'Division South', 'Division Central'];
const vendorSubDivs   = ['Sub-Div A', 'Sub-Div B', 'Sub-Div C', 'Sub-Div D', 'Sub-Div E'];
const vendorInverters = ['Sofar', 'Growatt', 'Solis', 'Delta', 'Sungrow'];
const faultCodes      = ['FT1 Ground Fault', 'FT2 Over-voltage', 'FT3 MPPT Error', 'FT4 High Temperature', 'FT5 Arc Fault'];
const alarmTexts      = ['FT4 High Temperature', 'FT2 Over-voltage', 'FT1 Ground Fault', 'FT3 MPPT Error', 'Communication Loss'];
const commissionStatuses: VendorPlant['commissionStatus'][] = ['COMMISSIONED', 'COMMISSIONED', 'COMMISSIONED', 'PENDING', 'UNDER_TEST', 'INACTIVE'];

// Deterministic pseudo-random: avoids re-renders changing counts
function det(i: number, mod: number, offset = 0): number {
  return ((i * 2654435761 + offset) >>> 0) % mod;
}

function generateVendorPlants(): VendorPlant[] {
  const plants: VendorPlant[] = [];
  for (let i = 1; i <= 342; i++) {
    // Deterministic PR in range 55–92
    const prVal = 55 + det(i, 38);
    const cap   = [3, 5, 6, 8, 10][i % 5];
    const statusOptions: PlantStatus[] = [PlantStatus.ONLINE, PlantStatus.ONLINE, PlantStatus.ONLINE, PlantStatus.OFFLINE, PlantStatus.WARNING];
    const status = i === 1 ? PlantStatus.ONLINE : statusOptions[i % statusOptions.length];
    const isOffline = status === PlantStatus.OFFLINE;
    const isWarning = status === PlantStatus.WARNING;

    // PR trend: ~12% of plants show 7-day decline
    const declining = det(i, 9) === 0;
    const prTrend7d = declining
      ? [prVal + 6, prVal + 5, prVal + 4, prVal + 3, prVal + 2, prVal + 1, prVal]
      : Array.from({ length: 7 }, (_, d) => prVal + det(i + d, 6) - 3);

    // Baseline 90-day PR (typically 3–8 pts above current for degraded plants)
    const baselinePR90d = parseFloat((prVal + det(i, 8) + 1).toFixed(1));

    // Peer PR avg by pincode group (5 pincodes → 5 peer groups)
    const pincodeGroup = i % 5;
    const peerPRAvg    = 72 + det(pincodeGroup, 10);

    // CUF on solar hours (~6h for Gujarat). CUF = (kWh / (cap × solarHours)) × 100
    const todayKWh  = parseFloat((cap * (prVal / 100) * 5.8 + det(i, 4) * 0.3).toFixed(1));
    const cufPercent = parseFloat(((todayKWh / (cap * 6)) * 100).toFixed(1));

    // Specific yield this month: kWh/kWp. Typical 90–140; low = <85
    const specificYieldMonthly = parseFloat((prVal * 1.4 + det(i, 20) - 10).toFixed(1));

    // Availability: % of solar hours inverter was generating
    const availabilityPercent = isOffline ? det(i, 40) + 30
      : isWarning ? det(i, 20) + 65
      : det(i, 15) + 84;

    // RMS / inverter connectivity
    const rmsOfflineMinutes: number | null = det(i, 14) === 0 ? det(i, 60) + 35 : null;
    const inverterSilentMinutes: number | null = rmsOfflineMinutes === null && det(i, 18) === 0 ? det(i, 45) + 32 : null;

    // Fault flags
    const hasFaultFlag = (isOffline || isWarning) && det(i, 3) === 0;
    const faultCode    = hasFaultFlag ? faultCodes[det(i, faultCodes.length)] : null;
    const faultAlarm   = hasFaultFlag ? alarmTexts[det(i, alarmTexts.length)] : null;

    // GHI below seasonal norm (~5% of plants)
    const ghiBelowNorm = !hasFaultFlag && det(i, 20) === 0;

    const alarmCount   = (isOffline || isWarning) ? (hasFaultFlag ? 2 : 1) : 0;
    const lastAlarmText = alarmCount > 0 ? (faultAlarm ?? alarmTexts[det(i, alarmTexts.length)]) : null;

    const openTickets  = i % 10 === 0 ? 1 : 0;

    plants.push({
      id:                   `ZB-${String(i).padStart(4, '0')}`,
      consumerName:         `Consumer ${i}`,
      consumerNumber:       `CN-${String(100000 + i)}`,
      mobile:               `98${String(700000000 + i * 7).slice(0, 9)}`,
      meterNumber:          `MTR${String(200000 + i * 3)}`,
      state:                vendorStates[i % vendorStates.length],
      district:             vendorDistricts[i % vendorDistricts.length],
      town:                 vendorTowns[i % vendorTowns.length],
      pincode:              vendorPincodes[pincodeGroup],
      village:              vendorVillages[i % vendorVillages.length],
      circle:               vendorCircles[i % vendorCircles.length],
      division:             vendorDivisions[i % vendorDivisions.length],
      subDivision:          vendorSubDivs[i % vendorSubDivs.length],
      inverterBrand:        vendorInverters[i % vendorInverters.length],
      status,
      todayKWh,
      prPercent:            prVal,
      prTrend7d,
      baselinePR90d,
      peerPRAvg,
      cufPercent,
      specificYieldMonthly,
      availabilityPercent,
      lastSeen:             '2026-04-28T11:00:00',
      activeAlarms:         alarmCount,
      lastAlarmText,
      ticketStatus:         openTickets > 0 ? TicketStatus.OPEN : null,
      openTickets,
      commissionStatus:     commissionStatuses[i % commissionStatuses.length],
      capacityKWp:          cap,
      plantAgeYears:        [1, 2, 3, 4, 5][i % 5],
      hasFaultFlag,
      faultCode,
      rmsOfflineMinutes,
      inverterSilentMinutes,
      ghiBelowNorm,
    });
  }
  return plants;
}

export const vendorPlants: VendorPlant[] = generateVendorPlants();

export const vendorKPIs = {
  totalPlants: 342,
  totalCapacityMWp: 1.8,
  todayMWh: 6.2,
  activePlants: 324,
  offlinePlants: 18,
  lowPRPlants: 31,
  commissioned: 298,
  pending: 28,
  underTest: 12,
  inactive: 4,
  avgCufPct: 18.9,
  co2OffsetMT: 0.22,
  avgPrPct: 78.4,
};

export const vendorTickets: ServiceTicket[] = [
  {
    id: 'TKT-2024-0481',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Inverter / MPPT fault',
    description: 'MPPT 2 output consistently lower',
    raisedDate: '2026-04-26',
    assignedTo: 'Ravi Kumar',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.OPEN,
    priority: 'NORMAL',
  },
  {
    id: 'TKT-2024-0467',
    plantId: 'ZB-0023',
    consumerName: 'Bharat Shah',
    issueType: 'Communication failure',
    description: 'Datalogger offline since morning',
    raisedDate: '2026-04-27',
    assignedTo: 'Priya Shah',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.IN_PROGRESS,
    priority: 'HIGH',
    resolutionTime: undefined,
  },
  {
    id: 'TKT-2024-0441',
    plantId: 'ZB-0101',
    consumerName: 'Lalitha Devi',
    issueType: 'Inverter shutdown',
    description: 'Grid fault caused inverter trip',
    raisedDate: '2026-04-20',
    assignedTo: 'Suresh Patel',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.RESOLVED,
    priority: 'HIGH',
    resolutionTime: '1.5 days',
  },
  {
    id: 'TKT-2024-0398',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Communication / Datalogger issue',
    description: 'Datalogger offline intermittently',
    raisedDate: '2026-04-25',
    assignedTo: 'Priya Shah',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.RESOLVED,
    priority: 'LOW',
    resolutionTime: '0.5 days',
  },
];

// ─── DISCOM (PGVCL) KPIs ──────────────────────────────────────────────────────
export const pgvclKPIs = {
  feederGenerationMW: 148.4,
  avgFeederVoltage: 241.3,
  solarPenetrationPercent: 18.6,
  activeAlarms: 58,
  sldcFeedStatus: 'LIVE',
  importMWh: 312.4,
  exportMWh: 289.6,
  risingDemandMW: 42.1,
  gridFailureEvents: 2,
  tamperCount: 7,
};

// ─── Feeder Data ──────────────────────────────────────────────────────────────
export const feeders: FeederData[] = [
  { id: 'FDR-AMD-01', name: 'Satellite Road Feeder', circle: 'Ahmedabad', generationMW: 18.4, plants: 124, penetrationPercent: 22.1, avgVoltage: 242, alarms: 3 },
  { id: 'FDR-AMD-02', name: 'Bopal Feeder', circle: 'Ahmedabad', generationMW: 14.2, plants: 98, penetrationPercent: 18.4, avgVoltage: 240, alarms: 1 },
  { id: 'FDR-GND-01', name: 'Gandhinagar Sector 8', circle: 'Gandhinagar', generationMW: 12.6, plants: 87, penetrationPercent: 19.8, avgVoltage: 241, alarms: 2 },
  { id: 'FDR-ANK-01', name: 'GIDC Feeder', circle: 'Ankleshwar', generationMW: 9.8, plants: 64, penetrationPercent: 15.2, avgVoltage: 239, alarms: 0 },
  { id: 'FDR-MEH-01', name: 'Mehsana North Feeder', circle: 'Mehsana', generationMW: 8.1, plants: 52, penetrationPercent: 14.6, avgVoltage: 243, alarms: 1 },
];

// ─── Net metering — import/export bars ───────────────────────────────────────
export const pgvclImportExportData = [
  { month: 'Nov', import: 241.2, export: 218.4 },
  { month: 'Dec', import: 228.6, export: 201.3 },
  { month: 'Jan', import: 258.1, export: 234.7 },
  { month: 'Feb', import: 281.4, export: 261.8 },
  { month: 'Mar', import: 304.2, export: 280.9 },
  { month: 'Apr', import: 312.4, export: 289.6 },
];

// ─── Variance Alerts ──────────────────────────────────────────────────────────
export const varianceAlerts: VarianceAlert[] = [
  { plantId: 'GJ-1842', consumerName: 'Vinod Mehta', inverterKWh: 28.4, meterKWh: 26.2, variancePercent: 7.7, status: 'REVIEW' },
  { plantId: 'GJ-0934', consumerName: 'Meena Trivedi', inverterKWh: 31.2, meterKWh: 28.8, variancePercent: 7.7, status: 'REVIEW' },
  { plantId: 'GJ-2201', consumerName: 'Ashok Bhatt', inverterKWh: 22.8, meterKWh: 20.9, variancePercent: 8.3, status: 'REVIEW' },
  { plantId: 'GJ-1101', consumerName: 'Sonal Desai', inverterKWh: 18.4, meterKWh: 17.8, variancePercent: 3.3, status: 'CLEAR' },
];

// ─── Command Logs ─────────────────────────────────────────────────────────────
export const commandLogs: CommandLog[] = [
  { timestamp: '2026-04-28T10:30:00', command: 'Voltage Setpoint → 242V', issuedBy: 'Er. Mehta (PGVCL)', plantId: 'FDR-AMD-01', result: 'SUCCESS' },
  { timestamp: '2026-04-27T14:15:00', command: 'Reactive Power → 0.8 kVAr', issuedBy: 'Er. Mehta (PGVCL)', plantId: 'FDR-GND-01', result: 'SUCCESS' },
  { timestamp: '2026-04-26T09:00:00', command: 'Voltage Setpoint → 240V', issuedBy: 'Er. Joshi (PGVCL)', plantId: 'FDR-AMD-02', result: 'FAILED' },
  { timestamp: '2026-04-25T16:45:00', command: 'Reactive Power → 0.6 kVAr', issuedBy: 'Er. Joshi (PGVCL)', plantId: 'FDR-ANK-01', result: 'SUCCESS' },
];

// ─── State KPIs ───────────────────────────────────────────────────────────────
export const gujaratStateKPIs = {
  plants: 6240,
  capacityGWp: 2.1,
  generationGWh: 9.84,
  activePercent: 91,
  offlineFaultCount: 562,
  discoms: 4,
  districts: 33,
  alarms: 142,
  avgPR: 78.2,
  avgCufPct: 19.2,
  co2OffsetMT: 0.84,
};

// ─── State-scoped fault distribution (separate ref for StateAlarms donut) ────
export const stateFaultDistribution: FaultDistribution[] = [
  { name: 'Comms Loss', value: 38, color: '#2472C8' },
  { name: 'Voltage Fault', value: 26, color: '#B52020' },
  { name: 'Temperature', value: 16, color: '#C25A0A' },
  { name: 'Frequency', value: 12, color: '#5B3FA6' },
  { name: 'Other', value: 8, color: '#0D6B5A' },
];

// ─── Consumer — last 15 min energy ───────────────────────────────────────────
export const consumerLast15MinKwh = 1.05;

// ─── DISCOM (PGVCL) Overview KPIs ────────────────────────────────────────────
export const pgvclOverview = {
  totalPlants: 2840,
  capacityMWp: 96.4,
  todayMWh: 1824,
  activePlants: 2690,
  activePct: 94.7,
  offlinePlants: 150,
  avgPR: 78.9,
  avgCUF: 19.2,
  co2OffsetMT: 0.41,
  avgCufPct: 19.8,
  discomCo2OffsetMT: 0.18,
  sldcFeedStatus: 'LIVE' as 'LIVE' | 'OFFLINE',
  avgSpecificYield: 4.58,
};

// ─── PGVCL Generation — 15-day daily trend ───────────────────────────────────
export const pgvclGeneration = {
  daily: [
    { label: '14 Apr', value: 1604 },
    { label: '15 Apr', value: 1718 },
    { label: '16 Apr', value: 1653 },
    { label: '17 Apr', value: 1542 },
    { label: '18 Apr', value: 1810 },
    { label: '19 Apr', value: 1890 },
    { label: '20 Apr', value: 1752 },
    { label: '21 Apr', value: 1688 },
    { label: '22 Apr', value: 1830 },
    { label: '23 Apr', value: 1760 },
    { label: '24 Apr', value: 1695 },
    { label: '25 Apr', value: 1920 },
    { label: '26 Apr', value: 1875 },
    { label: '27 Apr', value: 1840 },
    { label: '28 Apr', value: 1824, highlighted: true },
  ] as GenerationDataPoint[],
  circleWise: [
    { label: 'Ahmedabad', value: 684 },
    { label: 'Gandhinagar', value: 428 },
    { label: 'Mehsana', value: 312 },
    { label: 'Ankleshwar', value: 248 },
    { label: 'Rajkot', value: 152 },
  ] as GenerationDataPoint[],
  topPlants: [
    { id: 'GJ-0182', consumer: 'Infosys Ltd', capacityKWp: 500, todayMWh: 2.84, prPercent: 83.2 },
    { id: 'GJ-0344', consumer: 'Adani Group', capacityKWp: 450, todayMWh: 2.61, prPercent: 82.4 },
    { id: 'GJ-1022', consumer: 'TCS Gandhinagar', capacityKWp: 400, todayMWh: 2.38, prPercent: 81.9 },
    { id: 'GJ-0781', consumer: 'Sun Pharma', capacityKWp: 380, todayMWh: 2.20, prPercent: 81.4 },
    { id: 'GJ-0490', consumer: 'GNFC Bharuch', capacityKWp: 350, todayMWh: 2.08, prPercent: 80.8 },
  ],
  bottomPlants: [
    { id: 'GJ-1842', consumer: 'Vinod Mehta', capacityKWp: 6, todayMWh: 0.021, prPercent: 46.2 },
    { id: 'GJ-2201', consumer: 'Ashok Bhatt', capacityKWp: 5, todayMWh: 0.018, prPercent: 49.1 },
    { id: 'GJ-0934', consumer: 'Meena Trivedi', capacityKWp: 8, todayMWh: 0.032, prPercent: 51.4 },
    { id: 'GJ-1543', consumer: 'Ramesh Amin', capacityKWp: 6, todayMWh: 0.028, prPercent: 54.8 },
    { id: 'GJ-0718', consumer: 'Kavita Shah', capacityKWp: 10, todayMWh: 0.052, prPercent: 56.3 },
  ],
  avgSpecificYield: 4.58,
};

// ─── Zebron Solar (Vendor) Generation data ────────────────────────────────────
export const zebronGeneration = {
  daily: [
    { label: '14 Apr', value: 2812 },
    { label: '15 Apr', value: 2940 },
    { label: '16 Apr', value: 2784 },
    { label: '17 Apr', value: 2645 },
    { label: '18 Apr', value: 3018 },
    { label: '19 Apr', value: 3142 },
    { label: '20 Apr', value: 2960 },
    { label: '21 Apr', value: 2876 },
    { label: '22 Apr', value: 3080 },
    { label: '23 Apr', value: 2982 },
    { label: '24 Apr', value: 2845 },
    { label: '25 Apr', value: 3210 },
    { label: '26 Apr', value: 3180 },
    { label: '27 Apr', value: 3124 },
    { label: '28 Apr', value: 3096, highlighted: true },
  ] as GenerationDataPoint[],
  stateWise: [
    { label: 'Gujarat', value: 1480 },
    { label: 'Rajasthan', value: 682 },
    { label: 'Maharashtra', value: 524 },
    { label: 'Karnataka', value: 248 },
    { label: 'Tamil Nadu', value: 162 },
  ] as GenerationDataPoint[],
  topPlants: [
    { id: 'GJ-0182', consumer: 'Infosys Ltd', capacityKWp: 500, todayKWh: 2840, prPercent: 83.2 },
    { id: 'RJ-0441', consumer: 'Rajasthan Petro', capacityKWp: 480, todayKWh: 2720, prPercent: 82.8 },
    { id: 'MH-1102', consumer: 'Mahindra Nashik', capacityKWp: 420, todayKWh: 2450, prPercent: 82.1 },
    { id: 'GJ-0344', consumer: 'Adani Group', capacityKWp: 450, todayKWh: 2610, prPercent: 81.9 },
    { id: 'KA-0288', consumer: 'Wipro Bengaluru', capacityKWp: 400, todayKWh: 2240, prPercent: 81.4 },
  ],
  bottomPlants: [
    { id: 'GJ-1842', consumer: 'Vinod Mehta', capacityKWp: 6, todayKWh: 21, prPercent: 46.2 },
    { id: 'MH-0812', consumer: 'Datta Jadhav', capacityKWp: 5, todayKWh: 18, prPercent: 48.9 },
    { id: 'GJ-2201', consumer: 'Ashok Bhatt', capacityKWp: 5, todayKWh: 18, prPercent: 49.1 },
    { id: 'RJ-1204', consumer: 'Hanuman Farms', capacityKWp: 10, todayKWh: 44, prPercent: 51.8 },
    { id: 'GJ-0934', consumer: 'Meena Trivedi', capacityKWp: 8, todayKWh: 32, prPercent: 51.4 },
  ],
  peakPowerMW: 248,
  avgSpecificYield: 3.42,
};

// ─── State Generation — Top 5 plants & PR trend ───────────────────────────────
export const stateTopPlants = [
  { id: 'GJ-1024', district: 'Ahmedabad', kwhToday: 48.2, prPct: 88.4 },
  { id: 'GJ-0482', district: 'Ahmedabad', kwhToday: 45.5, prPct: 87.1 },
  { id: 'GJ-0731', district: 'Surat',     kwhToday: 44.8, prPct: 86.3 },
  { id: 'GJ-1204', district: 'Rajkot',    kwhToday: 43.9, prPct: 85.9 },
  { id: 'GJ-0890', district: 'Vadodara',  kwhToday: 42.1, prPct: 85.2 },
];

// ─── National generation — monthly series ─────────────────────────────────────
export const nationalMonthlyByState: GenerationDataPoint[] = [
  { label: 'Rajasthan',    value: 7.24 },
  { label: 'Gujarat',      value: 5.81 },
  { label: 'Karnataka',    value: 4.12 },
  { label: 'Andhra Pradesh', value: 3.89 },
  { label: 'Tamil Nadu',   value: 3.42 },
  { label: 'Maharashtra',  value: 2.94 },
  { label: 'Others',       value: 8.58 },
];

// ─── National Generation 30-day combo chart (actual + GHI-expected + GHI) ──────
export interface GenChartPoint {
  date: string;
  actual: number;   // GWh actual
  expected: number; // GWh GHI-expected (capacity × GHI × 0.80)
  ghi: number;      // W/m² daily avg irradiance
}

export const nationalGenChart30d: GenChartPoint[] = [
  { date: '29 Mar', actual: 30.1, expected: 33.6, ghi: 462 },
  { date: '30 Mar', actual: 29.4, expected: 31.2, ghi: 428 },
  { date: '31 Mar', actual: 31.8, expected: 34.8, ghi: 478 },
  { date: '1 Apr',  actual: 32.6, expected: 34.2, ghi: 469 },
  { date: '2 Apr',  actual: 33.2, expected: 35.5, ghi: 487 },
  { date: '3 Apr',  actual: 31.0, expected: 33.9, ghi: 465 },
  { date: '4 Apr',  actual: 28.4, expected: 30.2, ghi: 414 },
  { date: '5 Apr',  actual: 34.1, expected: 36.0, ghi: 494 },
  { date: '6 Apr',  actual: 33.8, expected: 35.8, ghi: 491 },
  { date: '7 Apr',  actual: 35.2, expected: 37.1, ghi: 509 },
  { date: '8 Apr',  actual: 34.6, expected: 36.4, ghi: 499 },
  { date: '9 Apr',  actual: 29.9, expected: 32.1, ghi: 440 },
  { date: '10 Apr', actual: 27.2, expected: 29.5, ghi: 404 },
  { date: '11 Apr', actual: 33.5, expected: 35.2, ghi: 483 },
  { date: '12 Apr', actual: 34.9, expected: 36.8, ghi: 505 },
  { date: '13 Apr', actual: 33.2, expected: 35.0, ghi: 480 },
  { date: '14 Apr', actual: 34.8, expected: 36.6, ghi: 502 },
  { date: '15 Apr', actual: 31.5, expected: 33.4, ghi: 458 },
  { date: '16 Apr', actual: 35.1, expected: 36.9, ghi: 506 },
  { date: '17 Apr', actual: 36.4, expected: 38.2, ghi: 524 },
  { date: '18 Apr', actual: 34.9, expected: 36.7, ghi: 503 },
  { date: '19 Apr', actual: 32.8, expected: 34.6, ghi: 475 },
  { date: '20 Apr', actual: 37.2, expected: 38.8, ghi: 532 },
  { date: '21 Apr', actual: 35.6, expected: 37.4, ghi: 513 },
  { date: '22 Apr', actual: 38.1, expected: 39.5, ghi: 542 },
  { date: '23 Apr', actual: 36.9, expected: 38.3, ghi: 525 },
  { date: '24 Apr', actual: 35.4, expected: 37.1, ghi: 509 },
  { date: '25 Apr', actual: 37.8, expected: 39.2, ghi: 538 },
  { date: '26 Apr', actual: 33.9, expected: 35.8, ghi: 491 },
  { date: '27 Apr', actual: 36.0, expected: 37.9, ghi: 520 },
];

export const nationalGenChartMonthly: GenChartPoint[] = [
  { date: 'May 25',  actual: 698,  expected: 735,  ghi: 502 },
  { date: 'Jun 25',  actual: 612,  expected: 648,  ghi: 442 },
  { date: 'Jul 25',  actual: 581,  expected: 618,  ghi: 422 },
  { date: 'Aug 25',  actual: 624,  expected: 660,  ghi: 451 },
  { date: 'Sep 25',  actual: 671,  expected: 706,  ghi: 482 },
  { date: 'Oct 25',  actual: 718,  expected: 750,  ghi: 512 },
  { date: 'Nov 25',  actual: 718,  expected: 752,  ghi: 513 },
  { date: 'Dec 25',  actual: 652,  expected: 688,  ghi: 470 },
  { date: 'Jan 26',  actual: 741,  expected: 775,  ghi: 529 },
  { date: 'Feb 26',  actual: 798,  expected: 832,  ghi: 568 },
  { date: 'Mar 26',  actual: 864,  expected: 898,  ghi: 614 },
  { date: 'Apr 26',  actual: 892,  expected: 928,  ghi: 634 },
];

export const nationalGenChartHourly: GenChartPoint[] = [
  { date: '6:00',  actual: 2.1,  expected: 2.6,  ghi: 36  },
  { date: '6:30',  actual: 4.8,  expected: 5.9,  ghi: 81  },
  { date: '7:00',  actual: 8.4,  expected: 10.1, ghi: 138 },
  { date: '7:30',  actual: 13.2, expected: 15.4, ghi: 211 },
  { date: '8:00',  actual: 18.6, expected: 21.3, ghi: 292 },
  { date: '8:30',  actual: 23.4, expected: 26.8, ghi: 367 },
  { date: '9:00',  actual: 28.3, expected: 32.1, ghi: 440 },
  { date: '9:30',  actual: 32.1, expected: 36.2, ghi: 496 },
  { date: '10:00', actual: 34.7, expected: 39.1, ghi: 536 },
  { date: '10:30', actual: 36.8, expected: 41.4, ghi: 568 },
  { date: '11:00', actual: 38.9, expected: 43.5, ghi: 596 },
  { date: '11:30', actual: 39.8, expected: 44.4, ghi: 609 },
  { date: '12:00', actual: 40.2, expected: 44.8, ghi: 615 },
  { date: '12:30', actual: 39.6, expected: 44.1, ghi: 605 },
  { date: '13:00', actual: 39.1, expected: 43.6, ghi: 598 },
  { date: '13:30', actual: 37.4, expected: 41.8, ghi: 573 },
  { date: '14:00', actual: 36.8, expected: 41.0, ghi: 562 },
  { date: '14:30', actual: 34.2, expected: 38.2, ghi: 524 },
  { date: '15:00', actual: 31.4, expected: 35.2, ghi: 483 },
  { date: '15:30', actual: 27.6, expected: 31.0, ghi: 425 },
  { date: '16:00', actual: 22.6, expected: 25.6, ghi: 351 },
  { date: '16:30', actual: 17.1, expected: 19.4, ghi: 266 },
  { date: '17:00', actual: 12.1, expected: 13.8, ghi: 189 },
  { date: '17:30', actual: 7.4,  expected: 8.5,  ghi: 117 },
  { date: '18:00', actual: 3.4,  expected: 3.9,  ghi: 53  },
];

// ─── National DISCOM list (multi-state) ───────────────────────────────────────
export interface NationalDISCOM {
  id: string;
  name: string;
  state: string;
  plants: number;
  capacityGWp: number;
  generationGWh: number;
  prPercent: number;
  activePercent: number;
  alarms: number;
  momTrend: number;
  specificYield: number; // kWh/kWp monthly avg
}

export const nationalDISCOMs: NationalDISCOM[] = [
  { id: 'PGVCL', name: 'PGVCL', state: 'Gujarat', plants: 2840, capacityGWp: 0.96, generationGWh: 4.48, prPercent: 79.1, activePercent: 92.0, alarms: 58, momTrend: 2.4, specificYield: 4.12 },
  { id: 'MGVCL', name: 'MGVCL', state: 'Gujarat', plants: 1680, capacityGWp: 0.56, generationGWh: 2.64, prPercent: 77.8, activePercent: 90.0, alarms: 41, momTrend: 1.1, specificYield: 3.98 },
  { id: 'DGVCL', name: 'DGVCL', state: 'Gujarat', plants:  980, capacityGWp: 0.33, generationGWh: 1.54, prPercent: 76.2, activePercent: 89.5, alarms: 28, momTrend: -0.8, specificYield: 3.87 },
  { id: 'UGVCL', name: 'UGVCL', state: 'Gujarat', plants:  740, capacityGWp: 0.25, generationGWh: 1.18, prPercent: 78.5, activePercent: 91.2, alarms: 15, momTrend: 0.6, specificYield: 4.03 },
  { id: 'TANGEDCO', name: 'TANGEDCO', state: 'Tamil Nadu', plants: 3240, capacityGWp: 1.08, generationGWh: 5.14, prPercent: 77.2, activePercent: 90.1, alarms: 62, momTrend: 1.8, specificYield: 3.96 },
  { id: 'TNEB-N', name: 'TNEB North', state: 'Tamil Nadu', plants: 1880, capacityGWp: 0.72, generationGWh: 2.98, prPercent: 75.9, activePercent: 88.2, alarms: 36, momTrend: -0.4, specificYield: 3.82 },
  { id: 'JVVNL', name: 'JVVNL', state: 'Rajasthan', plants: 2140, capacityGWp: 0.74, generationGWh: 3.21, prPercent: 76.4, activePercent: 88.0, alarms: 104, momTrend: -1.2, specificYield: 3.89 },
  { id: 'AVVNL', name: 'AVVNL', state: 'Rajasthan', plants: 1480, capacityGWp: 0.51, generationGWh: 1.98, prPercent: 73.8, activePercent: 85.3, alarms: 82, momTrend: -2.1, specificYield: 3.64 },
  { id: 'JdVVNL', name: 'JdVVNL', state: 'Rajasthan', plants:  760, capacityGWp: 0.25, generationGWh: 1.35, prPercent: 74.6, activePercent: 86.5, alarms: 25, momTrend: -0.9, specificYield: 3.75 },
  { id: 'MSEDCL', name: 'MSEDCL', state: 'Maharashtra', plants: 2680, capacityGWp: 0.88, generationGWh: 3.84, prPercent: 73.2, activePercent: 84.5, alarms: 124, momTrend: 0.3, specificYield: 3.68 },
  { id: 'BESCOM', name: 'BESCOM', state: 'Karnataka', plants: 1840, capacityGWp: 0.62, generationGWh: 2.69, prPercent: 75.1, activePercent: 87.2, alarms: 78, momTrend: 2.1, specificYield: 3.81 },
  { id: 'MPWZ', name: 'MPPKVVCL', state: 'Madhya Pradesh', plants: 1920, capacityGWp: 0.63, generationGWh: 2.14, prPercent: 65.8, activePercent: 76.4, alarms: 198, momTrend: -3.6, specificYield: 3.22 },
  { id: 'KSEBL', name: 'KSEBL', state: 'Kerala', plants: 1820, capacityGWp: 0.60, generationGWh: 1.82, prPercent: 66.2, activePercent: 75.8, alarms: 312, momTrend: -4.1, specificYield: 3.12 },
];

// ─── State monitoring data (for Monitoring screen) ───────────────────────────
export interface StateMonitoringRow {
  state: string;
  dataTxPercent: number;
  plantsOffline: number;
  activeAlarms: number;
  certsExpiring: number;
  firmwareOutdated: number;
}

export const stateMonitoringData: StateMonitoringRow[] = [
  { state: 'Gujarat',          dataTxPercent: 96.4, plantsOffline: 562,  activeAlarms: 142, certsExpiring: 12, firmwareOutdated: 48  },
  { state: 'Tamil Nadu',       dataTxPercent: 94.1, plantsOffline: 563,  activeAlarms:  98, certsExpiring:  8, firmwareOutdated: 35  },
  { state: 'Rajasthan',        dataTxPercent: 89.3, plantsOffline: 569,  activeAlarms: 211, certsExpiring: 18, firmwareOutdated: 72  },
  { state: 'Maharashtra',      dataTxPercent: 87.6, plantsOffline: 634,  activeAlarms: 187, certsExpiring: 14, firmwareOutdated: 58  },
  { state: 'Karnataka',        dataTxPercent: 83.2, plantsOffline: 453,  activeAlarms: 134, certsExpiring: 10, firmwareOutdated: 44  },
  { state: 'Madhya Pradesh',   dataTxPercent: 71.4, plantsOffline: 625,  activeAlarms: 298, certsExpiring: 22, firmwareOutdated: 89  },
  { state: 'Kerala',           dataTxPercent: 67.8, plantsOffline: 438,  activeAlarms: 312, certsExpiring: 26, firmwareOutdated: 94  },
  { state: 'Uttar Pradesh',    dataTxPercent: 78.2, plantsOffline: 382,  activeAlarms: 164, certsExpiring: 16, firmwareOutdated: 61  },
];

// ─── DISCOM monitoring data ───────────────────────────────────────────────────
export interface DISCOMMonitoringRow {
  discom: string;
  state: string;
  dataTxPercent: number;
  plantsOffline: number;
  activeAlarms: number;
  certsExpiring: number;
  firmwareOutdated: number;
}

export const discomMonitoringData: DISCOMMonitoringRow[] = [
  { discom: 'PGVCL',    state: 'Gujarat',       dataTxPercent: 97.2, plantsOffline: 227, activeAlarms:  58, certsExpiring:  5, firmwareOutdated: 18 },
  { discom: 'MGVCL',    state: 'Gujarat',       dataTxPercent: 95.8, plantsOffline: 168, activeAlarms:  41, certsExpiring:  4, firmwareOutdated: 15 },
  { discom: 'DGVCL',    state: 'Gujarat',       dataTxPercent: 96.1, plantsOffline:  98, activeAlarms:  28, certsExpiring:  2, firmwareOutdated:  9 },
  { discom: 'UGVCL',    state: 'Gujarat',       dataTxPercent: 95.4, plantsOffline:  69, activeAlarms:  15, certsExpiring:  1, firmwareOutdated:  6 },
  { discom: 'TANGEDCO', state: 'Tamil Nadu',    dataTxPercent: 94.8, plantsOffline: 324, activeAlarms:  62, certsExpiring:  5, firmwareOutdated: 22 },
  { discom: 'TNEB-N',   state: 'Tamil Nadu',    dataTxPercent: 93.2, plantsOffline: 239, activeAlarms:  36, certsExpiring:  3, firmwareOutdated: 13 },
  { discom: 'JVVNL',    state: 'Rajasthan',     dataTxPercent: 90.1, plantsOffline: 257, activeAlarms: 104, certsExpiring:  9, firmwareOutdated: 38 },
  { discom: 'AVVNL',    state: 'Rajasthan',     dataTxPercent: 87.4, plantsOffline: 216, activeAlarms:  82, certsExpiring:  7, firmwareOutdated: 24 },
  { discom: 'JdVVNL',   state: 'Rajasthan',     dataTxPercent: 88.9, plantsOffline:  96, activeAlarms:  25, certsExpiring:  2, firmwareOutdated: 10 },
  { discom: 'MSEDCL',   state: 'Maharashtra',   dataTxPercent: 87.6, plantsOffline: 413, activeAlarms: 124, certsExpiring:  8, firmwareOutdated: 34 },
  { discom: 'BESCOM',   state: 'Karnataka',     dataTxPercent: 83.2, plantsOffline: 237, activeAlarms:  78, certsExpiring:  6, firmwareOutdated: 28 },
  { discom: 'MPPKVVCL', state: 'Madhya Pradesh',dataTxPercent: 71.4, plantsOffline: 460, activeAlarms: 198, certsExpiring: 14, firmwareOutdated: 56 },
  { discom: 'KSEBL',    state: 'Kerala',        dataTxPercent: 67.8, plantsOffline: 438, activeAlarms: 312, certsExpiring: 18, firmwareOutdated: 71 },
];

// ─── District monitoring data (drill-down from state compliance table) ─────────
export interface DistrictMonitoringRow {
  district: string;
  state: string;
  dataTxPercent: number;
  plantsOffline: number;
  activeAlarms: number;
  certsExpiring: number;
  firmwareOutdated: number;
}

export const districtMonitoringData: DistrictMonitoringRow[] = [
  // Gujarat districts
  { district: 'Ahmedabad',    state: 'Gujarat', dataTxPercent: 97.8, plantsOffline:  31, activeAlarms: 22, certsExpiring: 3, firmwareOutdated:  8 },
  { district: 'Surat',        state: 'Gujarat', dataTxPercent: 96.2, plantsOffline:  21, activeAlarms: 18, certsExpiring: 2, firmwareOutdated:  6 },
  { district: 'Vadodara',     state: 'Gujarat', dataTxPercent: 95.4, plantsOffline:  16, activeAlarms: 14, certsExpiring: 2, firmwareOutdated:  5 },
  { district: 'Rajkot',       state: 'Gujarat', dataTxPercent: 96.8, plantsOffline:  13, activeAlarms: 11, certsExpiring: 1, firmwareOutdated:  4 },
  { district: 'Junagadh',     state: 'Gujarat', dataTxPercent: 94.1, plantsOffline:  10, activeAlarms:  9, certsExpiring: 1, firmwareOutdated:  3 },
  { district: 'Gandhinagar',  state: 'Gujarat', dataTxPercent: 97.1, plantsOffline:   7, activeAlarms:  6, certsExpiring: 1, firmwareOutdated:  2 },
  { district: 'Bharuch',      state: 'Gujarat', dataTxPercent: 95.9, plantsOffline:   9, activeAlarms:  8, certsExpiring: 1, firmwareOutdated:  3 },
  { district: 'Anand',        state: 'Gujarat', dataTxPercent: 96.3, plantsOffline:   8, activeAlarms:  7, certsExpiring: 1, firmwareOutdated:  3 },
  // Tamil Nadu districts
  { district: 'Chennai',      state: 'Tamil Nadu', dataTxPercent: 95.2, plantsOffline:  48, activeAlarms: 14, certsExpiring: 1, firmwareOutdated:  6 },
  { district: 'Coimbatore',   state: 'Tamil Nadu', dataTxPercent: 94.6, plantsOffline:  39, activeAlarms: 12, certsExpiring: 2, firmwareOutdated:  5 },
  { district: 'Madurai',      state: 'Tamil Nadu', dataTxPercent: 93.8, plantsOffline:  34, activeAlarms: 10, certsExpiring: 1, firmwareOutdated:  4 },
  { district: 'Salem',        state: 'Tamil Nadu', dataTxPercent: 92.4, plantsOffline:  31, activeAlarms:  9, certsExpiring: 1, firmwareOutdated:  4 },
  { district: 'Tirunelveli',  state: 'Tamil Nadu', dataTxPercent: 91.7, plantsOffline:  28, activeAlarms:  8, certsExpiring: 1, firmwareOutdated:  3 },
  // Rajasthan districts
  { district: 'Jaipur',       state: 'Rajasthan', dataTxPercent: 91.2, plantsOffline:  62, activeAlarms: 28, certsExpiring: 4, firmwareOutdated: 14 },
  { district: 'Jodhpur',      state: 'Rajasthan', dataTxPercent: 88.4, plantsOffline:  54, activeAlarms: 24, certsExpiring: 3, firmwareOutdated: 11 },
  { district: 'Udaipur',      state: 'Rajasthan', dataTxPercent: 86.9, plantsOffline:  48, activeAlarms: 21, certsExpiring: 3, firmwareOutdated:  9 },
  { district: 'Ajmer',        state: 'Rajasthan', dataTxPercent: 89.7, plantsOffline:  42, activeAlarms: 18, certsExpiring: 2, firmwareOutdated:  8 },
  // Maharashtra districts
  { district: 'Pune',         state: 'Maharashtra', dataTxPercent: 89.1, plantsOffline:  82, activeAlarms: 32, certsExpiring: 2, firmwareOutdated:  8 },
  { district: 'Mumbai',       state: 'Maharashtra', dataTxPercent: 88.2, plantsOffline:  74, activeAlarms: 28, certsExpiring: 2, firmwareOutdated:  7 },
  { district: 'Nashik',       state: 'Maharashtra', dataTxPercent: 86.4, plantsOffline:  68, activeAlarms: 24, certsExpiring: 2, firmwareOutdated:  6 },
  { district: 'Aurangabad',   state: 'Maharashtra', dataTxPercent: 85.8, plantsOffline:  61, activeAlarms: 21, certsExpiring: 1, firmwareOutdated:  6 },
  // Karnataka districts
  { district: 'Bengaluru',    state: 'Karnataka', dataTxPercent: 84.6, plantsOffline:  58, activeAlarms: 24, certsExpiring: 2, firmwareOutdated:  8 },
  { district: 'Mysuru',       state: 'Karnataka', dataTxPercent: 83.1, plantsOffline:  51, activeAlarms: 20, certsExpiring: 2, firmwareOutdated:  7 },
  { district: 'Belagavi',     state: 'Karnataka', dataTxPercent: 82.4, plantsOffline:  44, activeAlarms: 17, certsExpiring: 1, firmwareOutdated:  6 },
  // Madhya Pradesh districts
  { district: 'Bhopal',       state: 'Madhya Pradesh', dataTxPercent: 73.2, plantsOffline: 112, activeAlarms: 52, certsExpiring: 5, firmwareOutdated: 18 },
  { district: 'Indore',       state: 'Madhya Pradesh', dataTxPercent: 71.8, plantsOffline: 104, activeAlarms: 48, certsExpiring: 4, firmwareOutdated: 17 },
  { district: 'Jabalpur',     state: 'Madhya Pradesh', dataTxPercent: 69.4, plantsOffline:  98, activeAlarms: 44, certsExpiring: 4, firmwareOutdated: 15 },
  { district: 'Gwalior',      state: 'Madhya Pradesh', dataTxPercent: 68.1, plantsOffline:  91, activeAlarms: 41, certsExpiring: 4, firmwareOutdated: 14 },
  // Kerala districts
  { district: 'Thiruvananthapuram', state: 'Kerala', dataTxPercent: 69.4, plantsOffline: 108, activeAlarms: 78, certsExpiring: 5, firmwareOutdated: 18 },
  { district: 'Ernakulam',    state: 'Kerala', dataTxPercent: 67.2, plantsOffline:  98, activeAlarms: 72, certsExpiring: 5, firmwareOutdated: 17 },
  { district: 'Kozhikode',    state: 'Kerala', dataTxPercent: 65.8, plantsOffline:  91, activeAlarms: 66, certsExpiring: 4, firmwareOutdated: 16 },
  { district: 'Thrissur',     state: 'Kerala', dataTxPercent: 64.3, plantsOffline:  84, activeAlarms: 60, certsExpiring: 4, firmwareOutdated: 15 },
  // Uttar Pradesh districts
  { district: 'Lucknow',      state: 'Uttar Pradesh', dataTxPercent: 80.1, plantsOffline:  84, activeAlarms: 38, certsExpiring: 4, firmwareOutdated: 13 },
  { district: 'Agra',         state: 'Uttar Pradesh', dataTxPercent: 78.4, plantsOffline:  78, activeAlarms: 34, certsExpiring: 3, firmwareOutdated: 12 },
  { district: 'Varanasi',     state: 'Uttar Pradesh', dataTxPercent: 76.8, plantsOffline:  72, activeAlarms: 30, certsExpiring: 3, firmwareOutdated: 11 },
  { district: 'Kanpur',       state: 'Uttar Pradesh', dataTxPercent: 75.2, plantsOffline:  68, activeAlarms: 26, certsExpiring: 2, firmwareOutdated: 10 },
];

// ─── Circle monitoring data (drill-down from DISCOM compliance table) ──────────
export interface CircleMonitoringRow {
  circle: string;
  discom: string;
  dataTxPercent: number;
  plantsOffline: number;
  activeAlarms: number;
  certsExpiring: number;
  firmwareOutdated: number;
}

export const circleMonitoringData: CircleMonitoringRow[] = [
  // PGVCL circles
  { circle: 'Ahmedabad Circle',   discom: 'PGVCL',    dataTxPercent: 98.1, plantsOffline:  24, activeAlarms: 18, certsExpiring: 2, firmwareOutdated:  6 },
  { circle: 'Gandhinagar Circle', discom: 'PGVCL',    dataTxPercent: 97.4, plantsOffline:  18, activeAlarms: 12, certsExpiring: 1, firmwareOutdated:  4 },
  { circle: 'Ankleshwar Circle',  discom: 'PGVCL',    dataTxPercent: 97.8, plantsOffline:  14, activeAlarms:  9, certsExpiring: 1, firmwareOutdated:  3 },
  { circle: 'Kheda Circle',       discom: 'PGVCL',    dataTxPercent: 96.2, plantsOffline:  12, activeAlarms:  8, certsExpiring: 1, firmwareOutdated:  3 },
  { circle: 'Mehsana Circle',     discom: 'PGVCL',    dataTxPercent: 97.1, plantsOffline:  10, activeAlarms:  6, certsExpiring: 0, firmwareOutdated:  2 },
  // TANGEDCO circles
  { circle: 'Chennai Circle',     discom: 'TANGEDCO', dataTxPercent: 95.4, plantsOffline:  82, activeAlarms: 16, certsExpiring: 2, firmwareOutdated:  6 },
  { circle: 'Coimbatore Circle',  discom: 'TANGEDCO', dataTxPercent: 94.8, plantsOffline:  74, activeAlarms: 14, certsExpiring: 1, firmwareOutdated:  5 },
  { circle: 'Madurai Circle',     discom: 'TANGEDCO', dataTxPercent: 94.1, plantsOffline:  68, activeAlarms: 12, certsExpiring: 1, firmwareOutdated:  5 },
  { circle: 'Tirunelveli Circle', discom: 'TANGEDCO', dataTxPercent: 93.6, plantsOffline:  62, activeAlarms: 10, certsExpiring: 1, firmwareOutdated:  4 },
  // JVVNL circles
  { circle: 'Jaipur North',       discom: 'JVVNL',    dataTxPercent: 91.8, plantsOffline:  68, activeAlarms: 28, certsExpiring: 4, firmwareOutdated: 12 },
  { circle: 'Jaipur South',       discom: 'JVVNL',    dataTxPercent: 90.4, plantsOffline:  62, activeAlarms: 24, certsExpiring: 3, firmwareOutdated: 11 },
  { circle: 'Alwar Circle',       discom: 'JVVNL',    dataTxPercent: 89.2, plantsOffline:  58, activeAlarms: 21, certsExpiring: 2, firmwareOutdated:  9 },
  { circle: 'Bharatpur Circle',   discom: 'JVVNL',    dataTxPercent: 88.7, plantsOffline:  52, activeAlarms: 18, certsExpiring: 2, firmwareOutdated:  8 },
  // KSEBL circles
  { circle: 'Thiruvananthapuram C', discom: 'KSEBL',  dataTxPercent: 69.1, plantsOffline: 112, activeAlarms: 82, certsExpiring: 5, firmwareOutdated: 18 },
  { circle: 'Ernakulam Circle',   discom: 'KSEBL',    dataTxPercent: 67.4, plantsOffline: 102, activeAlarms: 76, certsExpiring: 5, firmwareOutdated: 17 },
  { circle: 'Kozhikode Circle',   discom: 'KSEBL',    dataTxPercent: 65.9, plantsOffline:  94, activeAlarms: 70, certsExpiring: 4, firmwareOutdated: 16 },
  { circle: 'Thrissur Circle',    discom: 'KSEBL',    dataTxPercent: 64.2, plantsOffline:  88, activeAlarms: 64, certsExpiring: 4, firmwareOutdated: 15 },
];

// ─── State Agency: District Analyser rows ────────────────────────────────────
export interface DistrictAnalyserRow {
  id: string;
  name: string;
  plants: number;
  capacityMWp: number;
  generationMWh: number;
  specificYield: number;  // kWh/kWp
  prPercent: number;
  availPercent: number;
  cufPercent: number;
  momTrend: number;
  alarms: number;
}

export const gujaratDistrictAnalyser: DistrictAnalyserRow[] = [
  { id: 'AMD', name: 'Ahmedabad',     plants: 911, capacityMWp: 306, generationMWh: 1438, specificYield: 4.70, prPercent: 78.4, availPercent: 92.1, cufPercent: 19.3, momTrend:  3.2, alarms: 22 },
  { id: 'SUR', name: 'Surat',         plants: 629, capacityMWp: 212, generationMWh:  975, specificYield: 4.60, prPercent: 76.9, availPercent: 90.8, cufPercent: 18.9, momTrend:  1.8, alarms: 16 },
  { id: 'VDR', name: 'Vadodara',      plants: 488, capacityMWp: 164, generationMWh:  759, specificYield: 4.63, prPercent: 77.2, availPercent: 91.4, cufPercent: 19.0, momTrend:  2.4, alarms: 12 },
  { id: 'RJK', name: 'Rajkot',        plants: 398, capacityMWp: 134, generationMWh:  641, specificYield: 4.78, prPercent: 79.8, availPercent: 93.2, cufPercent: 19.6, momTrend:  4.1, alarms:  9 },
  { id: 'JND', name: 'Junagadh',      plants: 308, capacityMWp: 104, generationMWh:  462, specificYield: 4.44, prPercent: 74.1, availPercent: 83.6, cufPercent: 18.2, momTrend: -1.8, alarms: 18 },
  { id: 'AND', name: 'Anand',         plants: 250, capacityMWp:  84, generationMWh:  383, specificYield: 4.56, prPercent: 76.1, availPercent: 90.2, cufPercent: 18.7, momTrend:  0.9, alarms: 10 },
  { id: 'KHD', name: 'Kheda',         plants: 199, capacityMWp:  67, generationMWh:  302, specificYield: 4.51, prPercent: 75.3, availPercent: 89.4, cufPercent: 18.5, momTrend:  1.2, alarms:  8 },
  { id: 'BHR', name: 'Bharuch',       plants: 270, capacityMWp:  91, generationMWh:  425, specificYield: 4.67, prPercent: 77.9, availPercent: 90.8, cufPercent: 19.1, momTrend:  2.1, alarms: 11 },
  { id: 'GND', name: 'Gandhinagar',   plants: 218, capacityMWp:  73, generationMWh:  339, specificYield: 4.64, prPercent: 77.5, availPercent: 91.1, cufPercent: 19.0, momTrend:  1.6, alarms:  8 },
  { id: 'KTC', name: 'Kachchh',       plants: 244, capacityMWp:  82, generationMWh:  375, specificYield: 4.57, prPercent: 76.3, availPercent: 89.9, cufPercent: 18.7, momTrend:  0.4, alarms: 10 },
  { id: 'BHV', name: 'Bhavnagar',     plants: 228, capacityMWp:  77, generationMWh:  354, specificYield: 4.60, prPercent: 76.8, availPercent: 90.1, cufPercent: 18.9, momTrend:  0.7, alarms:  9 },
  { id: 'JMN', name: 'Jamnagar',      plants: 189, capacityMWp:  64, generationMWh:  290, specificYield: 4.53, prPercent: 75.6, availPercent: 89.2, cufPercent: 18.6, momTrend: -0.3, alarms:  8 },
  { id: 'MHN', name: 'Mahesana',      plants: 183, capacityMWp:  62, generationMWh:  278, specificYield: 4.48, prPercent: 74.8, availPercent: 88.9, cufPercent: 18.4, momTrend: -0.8, alarms:  8 },
  { id: 'NVS', name: 'Navsari',       plants: 170, capacityMWp:  57, generationMWh:  257, specificYield: 4.50, prPercent: 75.1, availPercent: 89.3, cufPercent: 18.5, momTrend:  0.5, alarms:  7 },
  { id: 'SRN', name: 'Surendranagar', plants: 148, capacityMWp:  50, generationMWh:  219, specificYield: 4.37, prPercent: 72.9, availPercent: 86.4, cufPercent: 17.9, momTrend: -1.2, alarms:  7 },
  { id: 'AMR', name: 'Amreli',        plants: 153, capacityMWp:  53, generationMWh:  234, specificYield: 4.41, prPercent: 73.5, availPercent: 87.1, cufPercent: 18.1, momTrend: -0.6, alarms:  7 },
  { id: 'VLS', name: 'Valsad',        plants: 141, capacityMWp:  47, generationMWh:  210, specificYield: 4.46, prPercent: 74.5, availPercent: 88.4, cufPercent: 18.3, momTrend:  0.2, alarms:  6 },
  { id: 'BNK', name: 'Banas Kantha',  plants: 167, capacityMWp:  56, generationMWh:  243, specificYield: 4.34, prPercent: 72.4, availPercent: 84.2, cufPercent: 17.8, momTrend: -2.1, alarms: 10 },
  { id: 'PTN', name: 'Patan',         plants: 135, capacityMWp:  45, generationMWh:  199, specificYield: 4.43, prPercent: 73.9, availPercent: 87.8, cufPercent: 18.2, momTrend: -0.4, alarms:  6 },
  { id: 'PRB', name: 'Porbandar',     plants: 115, capacityMWp:  39, generationMWh:  174, specificYield: 4.45, prPercent: 74.2, availPercent: 88.1, cufPercent: 18.2, momTrend:  0.1, alarms:  5 },
  { id: 'SBK', name: 'Sabar Kantha',  plants: 125, capacityMWp:  42, generationMWh:  181, specificYield: 4.30, prPercent: 71.8, availPercent: 83.4, cufPercent: 17.7, momTrend: -1.6, alarms:  7 },
  { id: 'PMH', name: 'Panch Mahals',  plants: 112, capacityMWp:  38, generationMWh:  162, specificYield: 4.27, prPercent: 71.2, availPercent: 83.1, cufPercent: 17.5, momTrend: -1.9, alarms:  6 },
  { id: 'NRM', name: 'Narmada',       plants:  87, capacityMWp:  29, generationMWh:  122, specificYield: 4.21, prPercent: 70.1, availPercent: 82.3, cufPercent: 17.2, momTrend: -2.4, alarms:  5 },
  { id: 'DHD', name: 'Dahod',         plants:  93, capacityMWp:  31, generationMWh:  130, specificYield: 4.18, prPercent: 69.8, availPercent: 81.8, cufPercent: 17.2, momTrend: -2.8, alarms:  6 },
  { id: 'TAP', name: 'Tapi',          plants:  71, capacityMWp:  24, generationMWh:   99, specificYield: 4.13, prPercent: 68.9, availPercent: 81.2, cufPercent: 16.9, momTrend: -3.1, alarms:  4 },
  { id: 'DNG', name: 'The Dangs',     plants:  29, capacityMWp:  10, generationMWh:   40, specificYield: 4.03, prPercent: 67.2, availPercent: 79.4, cufPercent: 16.5, momTrend: -3.8, alarms:  3 },
];

// State average specific yield (for triage tile threshold)
export const gujaratAvgSpecificYield = 4.53;

// ─── State Agency: DISCOM Analyser rows (Gujarat-scoped) ─────────────────────
export interface StateDiscomRow {
  id: string;
  name: string;
  plants: number;
  capacityGWp: number;
  generationGWh: number;
  specificYield: number;
  prPercent: number;
  availPercent: number;
  cufPercent: number;
  momTrend: number;
  alarms: number;
}

export const gujaratStateDiscoms: StateDiscomRow[] = [
  { id: 'PGVCL', name: 'PGVCL', plants: 2840, capacityGWp: 0.96, generationGWh: 4.48, specificYield: 4.67, prPercent: 79.1, availPercent: 92.0, cufPercent: 19.5, momTrend:  2.8, alarms:  58 },
  { id: 'MGVCL', name: 'MGVCL', plants: 1680, capacityGWp: 0.56, generationGWh: 2.64, specificYield: 4.71, prPercent: 77.8, availPercent: 90.0, cufPercent: 19.1, momTrend:  1.4, alarms:  41 },
  { id: 'DGVCL', name: 'DGVCL', plants:  980, capacityGWp: 0.33, generationGWh: 1.54, specificYield: 4.67, prPercent: 76.2, availPercent: 89.5, cufPercent: 18.8, momTrend: -0.6, alarms:  28 },
  { id: 'UGVCL', name: 'UGVCL', plants:  740, capacityGWp: 0.25, generationGWh: 1.18, specificYield: 4.72, prPercent: 78.5, availPercent: 91.2, cufPercent: 19.3, momTrend:  0.9, alarms:  15 },
];

// ─── State Agency: Generation combo chart data ────────────────────────────────
// Same GenChartPoint format; generation in GWh at state scale (Gujarat ≈ 9.84 GWh/day)

export const stateGenChart30d: GenChartPoint[] = [
  { date: '29 Mar', actual:  8.2, expected:  9.2, ghi: 462 },
  { date: '30 Mar', actual:  8.0, expected:  8.5, ghi: 428 },
  { date: '31 Mar', actual:  8.7, expected:  9.5, ghi: 478 },
  { date: '1 Apr',  actual:  8.9, expected:  9.3, ghi: 469 },
  { date: '2 Apr',  actual:  9.1, expected:  9.7, ghi: 487 },
  { date: '3 Apr',  actual:  8.5, expected:  9.3, ghi: 465 },
  { date: '4 Apr',  actual:  7.8, expected:  8.2, ghi: 414 },
  { date: '5 Apr',  actual:  9.3, expected:  9.8, ghi: 494 },
  { date: '6 Apr',  actual:  9.2, expected:  9.8, ghi: 491 },
  { date: '7 Apr',  actual:  9.6, expected: 10.1, ghi: 509 },
  { date: '8 Apr',  actual:  9.4, expected:  9.9, ghi: 499 },
  { date: '9 Apr',  actual:  8.2, expected:  8.8, ghi: 440 },
  { date: '10 Apr', actual:  7.4, expected:  8.1, ghi: 404 },
  { date: '11 Apr', actual:  9.8, expected: 10.2, ghi: 514 },
  { date: '12 Apr', actual: 10.1, expected: 10.5, ghi: 528 },
  { date: '13 Apr', actual:  9.0, expected:  9.5, ghi: 478 },
  { date: '14 Apr', actual:  9.5, expected:  9.9, ghi: 499 },
  { date: '15 Apr', actual:  8.6, expected:  9.2, ghi: 462 },
  { date: '16 Apr', actual:  9.6, expected:  9.3, ghi: 469 },
  { date: '17 Apr', actual:  9.9, expected:  9.7, ghi: 487 },
  { date: '18 Apr', actual:  9.5, expected:  9.2, ghi: 465 },
  { date: '19 Apr', actual:  9.0, expected:  8.6, ghi: 433 },
  { date: '20 Apr', actual: 10.2, expected: 10.1, ghi: 508 },
  { date: '21 Apr', actual:  9.7, expected:  9.7, ghi: 490 },
  { date: '22 Apr', actual: 10.1, expected:  9.9, ghi: 499 },
  { date: '23 Apr', actual:  9.9, expected:  9.8, ghi: 495 },
  { date: '24 Apr', actual:  9.2, expected:  9.2, ghi: 464 },
  { date: '25 Apr', actual:  8.8, expected:  9.1, ghi: 459 },
  { date: '26 Apr', actual:  9.4, expected:  9.5, ghi: 480 },
  { date: '27 Apr', actual:  9.8, expected: 10.0, ghi: 503 },
];

export const stateGenChartMonthly: GenChartPoint[] = [
  { date: 'May 25',  actual: 278, expected: 295, ghi: 498 },
  { date: 'Jun 25',  actual: 241, expected: 258, ghi: 432 },
  { date: 'Jul 25',  actual: 218, expected: 241, ghi: 405 },
  { date: 'Aug 25',  actual: 229, expected: 248, ghi: 420 },
  { date: 'Sep 25',  actual: 252, expected: 268, ghi: 454 },
  { date: 'Oct 25',  actual: 274, expected: 288, ghi: 488 },
  { date: 'Nov 25',  actual: 281, expected: 292, ghi: 494 },
  { date: 'Dec 25',  actual: 261, expected: 278, ghi: 468 },
  { date: 'Jan 26',  actual: 269, expected: 283, ghi: 478 },
  { date: 'Feb 26',  actual: 258, expected: 271, ghi: 458 },
  { date: 'Mar 26',  actual: 288, expected: 299, ghi: 506 },
  { date: 'Apr 26',  actual: 295, expected: 305, ghi: 516 },
];

export const stateGenChartHourly: GenChartPoint[] = [
  { date: '6:00',  actual:  62,  expected:  68, ghi:  82 },
  { date: '6:30',  actual: 108,  expected: 119, ghi: 144 },
  { date: '7:00',  actual: 178,  expected: 193, ghi: 233 },
  { date: '7:30',  actual: 268,  expected: 288, ghi: 349 },
  { date: '8:00',  actual: 368,  expected: 391, ghi: 474 },
  { date: '8:30',  actual: 472,  expected: 498, ghi: 604 },
  { date: '9:00',  actual: 572,  expected: 598, ghi: 725 },
  { date: '9:30',  actual: 668,  expected: 693, ghi: 840 },
  { date: '10:00', actual: 748,  expected: 771, ghi: 935 },
  { date: '10:30', actual: 811,  expected: 831, ghi: 1008 },
  { date: '11:00', actual: 855,  expected: 872, ghi: 1057 },
  { date: '11:30', actual: 885,  expected: 901, ghi: 1094 },
  { date: '12:00', actual: 902,  expected: 918, ghi: 1114 },
  { date: '12:30', actual: 908,  expected: 921, ghi: 1117 },
  { date: '13:00', actual: 898,  expected: 914, ghi: 1109 },
  { date: '13:30', actual: 878,  expected: 895, ghi: 1086 },
  { date: '14:00', actual: 842,  expected: 862, ghi: 1045 },
  { date: '14:30', actual: 792,  expected: 814, ghi: 988 },
  { date: '15:00', actual: 728,  expected: 753, ghi: 913 },
  { date: '15:30', actual: 648,  expected: 675, ghi: 818 },
  { date: '16:00', actual: 551,  expected: 578, ghi: 701 },
  { date: '16:30', actual: 441,  expected: 468, ghi: 568 },
  { date: '17:00', actual: 322,  expected: 348, ghi: 422 },
  { date: '17:30', actual: 195,  expected: 218, ghi: 264 },
  { date: '18:00', actual:  82,  expected: 102, ghi: 124 },
];

// ─── PGVCL Sub-Division data (Sub-Division Analyser screen) ──────────────────
export interface PGVCLSubDivisionRow {
  id: string;
  name: string;
  circle: string;
  division: string;
  plants: number;
  capacityKWp: number;
  generationKWh: number;
  specificYield: number;
  prPercent: number;
  availPercent: number;
  cufPercent: number;
  momTrend: number;
  alarms: number;
}

export const pgvclSubDivisions: PGVCLSubDivisionRow[] = [
  // Ahmedabad Circle — North Division
  { id: 'AMD-N-1', name: 'Satellite Road', circle: 'Ahmedabad', division: 'North', plants: 108, capacityKWp: 1840, generationKWh: 8418, specificYield: 4.58, prPercent: 80.1, availPercent: 94.4, cufPercent: 19.8, momTrend:  3.1, alarms:  4 },
  { id: 'AMD-N-2', name: 'Bopal',          circle: 'Ahmedabad', division: 'North', plants:  96, capacityKWp: 1620, generationKWh: 7290, specificYield: 4.50, prPercent: 78.4, availPercent: 92.7, cufPercent: 19.2, momTrend:  1.8, alarms:  3 },
  { id: 'AMD-N-3', name: 'Chandkheda',     circle: 'Ahmedabad', division: 'North', plants:  84, capacityKWp: 1410, generationKWh: 6204, specificYield: 4.40, prPercent: 77.2, availPercent: 91.6, cufPercent: 18.9, momTrend: -0.4, alarms:  5 },
  // Ahmedabad Circle — Central Division
  { id: 'AMD-C-1', name: 'Maninagar',      circle: 'Ahmedabad', division: 'Central', plants:  92, capacityKWp: 1560, generationKWh: 7254, specificYield: 4.65, prPercent: 81.2, availPercent: 95.1, cufPercent: 20.1, momTrend:  2.6, alarms:  2 },
  { id: 'AMD-C-2', name: 'Narol',          circle: 'Ahmedabad', division: 'Central', plants:  88, capacityKWp: 1480, generationKWh: 6808, specificYield: 4.60, prPercent: 79.8, availPercent: 93.2, cufPercent: 19.6, momTrend:  1.4, alarms:  3 },
  { id: 'AMD-C-3', name: 'Vatva',          circle: 'Ahmedabad', division: 'Central', plants:  82, capacityKWp: 1380, generationKWh: 5934, specificYield: 4.30, prPercent: 74.2, availPercent: 88.4, cufPercent: 18.4, momTrend: -2.1, alarms:  8 },
  // Ahmedabad Circle — South Division
  { id: 'AMD-S-1', name: 'Sarkhej',        circle: 'Ahmedabad', division: 'South', plants:  98, capacityKWp: 1660, generationKWh: 7635, specificYield: 4.60, prPercent: 80.4, availPercent: 93.8, cufPercent: 19.9, momTrend:  2.2, alarms:  3 },
  { id: 'AMD-S-2', name: 'Sanand',         circle: 'Ahmedabad', division: 'South', plants:  86, capacityKWp: 1450, generationKWh: 6234, specificYield: 4.30, prPercent: 76.1, availPercent: 90.5, cufPercent: 18.5, momTrend: -1.2, alarms:  6 },
  { id: 'AMD-S-3', name: 'Bavla',          circle: 'Ahmedabad', division: 'South', plants:  86, capacityKWp: 1440, generationKWh: 5472, specificYield: 3.80, prPercent: 66.8, availPercent: 82.3, cufPercent: 16.2, momTrend: -4.8, alarms: 12 },
  // Gandhinagar Circle — East Division
  { id: 'GND-E-1', name: 'Sector 8',       circle: 'Gandhinagar', division: 'East', plants: 124, capacityKWp: 2100, generationKWh: 9870, specificYield: 4.70, prPercent: 82.1, availPercent: 95.2, cufPercent: 20.4, momTrend:  3.8, alarms:  2 },
  { id: 'GND-E-2', name: 'Sector 15',      circle: 'Gandhinagar', division: 'East', plants: 108, capacityKWp: 1820, generationKWh: 8372, specificYield: 4.60, prPercent: 80.4, availPercent: 93.5, cufPercent: 19.8, momTrend:  2.4, alarms:  3 },
  { id: 'GND-E-3', name: 'Mansa',          circle: 'Gandhinagar', division: 'East', plants:  96, capacityKWp: 1620, generationKWh: 7047, specificYield: 4.35, prPercent: 76.8, availPercent: 90.6, cufPercent: 18.6, momTrend:  0.8, alarms:  4 },
  // Gandhinagar Circle — West Division
  { id: 'GND-W-1', name: 'Kalol',          circle: 'Gandhinagar', division: 'West', plants: 118, capacityKWp: 1990, generationKWh: 8956, specificYield: 4.50, prPercent: 79.1, availPercent: 92.4, cufPercent: 19.3, momTrend:  1.6, alarms:  5 },
  { id: 'GND-W-2', name: 'Dehgam',         circle: 'Gandhinagar', division: 'West', plants:  96, capacityKWp: 1620, generationKWh: 6804, specificYield: 4.20, prPercent: 73.4, availPercent: 87.2, cufPercent: 18.0, momTrend: -1.8, alarms:  7 },
  { id: 'GND-W-3', name: 'Vijapur',        circle: 'Gandhinagar', division: 'West', plants:  98, capacityKWp: 1650, generationKWh: 6402, specificYield: 3.88, prPercent: 68.2, availPercent: 83.6, cufPercent: 16.6, momTrend: -3.2, alarms: 10 },
  // Ankleshwar Circle — East Division
  { id: 'ANK-E-1', name: 'GIDC Phase 1',   circle: 'Ankleshwar', division: 'East', plants: 142, capacityKWp: 2400, generationKWh:11424, specificYield: 4.76, prPercent: 83.2, availPercent: 96.1, cufPercent: 20.8, momTrend:  4.2, alarms:  1 },
  { id: 'ANK-E-2', name: 'GIDC Phase 2',   circle: 'Ankleshwar', division: 'East', plants: 128, capacityKWp: 2160, generationKWh: 9720, specificYield: 4.50, prPercent: 79.6, availPercent: 93.0, cufPercent: 19.4, momTrend:  2.1, alarms:  3 },
  // Ankleshwar Circle — West Division
  { id: 'ANK-W-1', name: 'Zadeshwar',      circle: 'Ankleshwar', division: 'West', plants: 136, capacityKWp: 2290, generationKWh:10787, specificYield: 4.71, prPercent: 82.4, availPercent: 95.2, cufPercent: 20.5, momTrend:  3.4, alarms:  2 },
  { id: 'ANK-W-2', name: 'Amod',           circle: 'Ankleshwar', division: 'West', plants: 114, capacityKWp: 1920, generationKWh: 7622, specificYield: 3.97, prPercent: 69.8, availPercent: 84.6, cufPercent: 17.0, momTrend: -2.8, alarms:  9 },
  // Kheda Circle — North Division
  { id: 'KDA-N-1', name: 'Nadiad',         circle: 'Kheda', division: 'North', plants: 102, capacityKWp: 1720, generationKWh: 7826, specificYield: 4.55, prPercent: 79.8, availPercent: 92.2, cufPercent: 19.5, momTrend:  2.0, alarms:  4 },
  { id: 'KDA-N-2', name: 'Anand',          circle: 'Kheda', division: 'North', plants:  94, capacityKWp: 1590, generationKWh: 6599, specificYield: 4.15, prPercent: 72.6, availPercent: 88.3, cufPercent: 17.8, momTrend: -0.9, alarms:  7 },
  // Kheda Circle — South Division
  { id: 'KDA-S-1', name: 'Petlad',         circle: 'Kheda', division: 'South', plants:  88, capacityKWp: 1490, generationKWh: 6257, specificYield: 4.20, prPercent: 73.8, availPercent: 89.1, cufPercent: 18.0, momTrend: -0.5, alarms:  5 },
  { id: 'KDA-S-2', name: 'Khambhat',       circle: 'Kheda', division: 'South', plants:  56, capacityKWp:  940, generationKWh: 3478, specificYield: 3.70, prPercent: 65.2, availPercent: 80.4, cufPercent: 15.9, momTrend: -5.2, alarms: 14 },
  // Mehsana Circle — North Division
  { id: 'MEH-N-1', name: 'Mehsana City',   circle: 'Mehsana', division: 'North', plants: 118, capacityKWp: 1990, generationKWh: 9313, specificYield: 4.68, prPercent: 81.6, availPercent: 94.8, cufPercent: 20.2, momTrend:  3.0, alarms:  2 },
  { id: 'MEH-N-2', name: 'Kadi',           circle: 'Mehsana', division: 'North', plants: 104, capacityKWp: 1750, generationKWh: 7875, specificYield: 4.50, prPercent: 78.9, availPercent: 92.2, cufPercent: 19.4, momTrend:  1.6, alarms:  3 },
  // Mehsana Circle — South Division
  { id: 'MEH-S-1', name: 'Visnagar',       circle: 'Mehsana', division: 'South', plants:  98, capacityKWp: 1650, generationKWh: 7260, specificYield: 4.40, prPercent: 77.1, availPercent: 91.8, cufPercent: 18.9, momTrend:  0.9, alarms:  3 },
  { id: 'MEH-S-2', name: 'Unjha',          circle: 'Mehsana', division: 'South', plants: 100, capacityKWp: 1690, generationKWh: 6490, specificYield: 3.84, prPercent: 67.4, availPercent: 83.1, cufPercent: 16.5, momTrend: -2.4, alarms: 11 },
];

export const pgvclAvgSpecificYield = 4.58;

// ─── PGVCL Circle panel data (for DISCOM Overview panel) ─────────────────────
export interface PGVCLCirclePanelData {
  id: string;
  name: string;
  totalPlants: number;
  capacityMWp: number;
  todayMWh: number;
  specificYield: number;
  avgPR: number;
  avgCUF: number;
  plantAvailability: number;
  activePlants: number;
  offlinePlants: number;
  activeAlarms: number;
}

export const pgvclCirclePanelData: PGVCLCirclePanelData[] = [
  { id: 'AMD-C', name: 'Ahmedabad Circle',   totalPlants: 920, capacityMWp: 31.2, todayMWh: 620, specificYield: 4.58, avgPR: 79.4, avgCUF: 19.6, plantAvailability: 93.2, activePlants: 858, offlinePlants: 62,  activeAlarms: 18 },
  { id: 'GND-C', name: 'Gandhinagar Circle', totalPlants: 640, capacityMWp: 21.7, todayMWh: 430, specificYield: 4.60, avgPR: 78.9, avgCUF: 19.4, plantAvailability: 91.8, activePlants: 588, offlinePlants: 52,  activeAlarms: 12 },
  { id: 'ANK-C', name: 'Ankleshwar Circle',  totalPlants: 520, capacityMWp: 17.6, todayMWh: 351, specificYield: 4.62, avgPR: 80.1, avgCUF: 19.8, plantAvailability: 94.0, activePlants: 489, offlinePlants: 31,  activeAlarms:  9 },
  { id: 'KDA-C', name: 'Kheda Circle',       totalPlants: 340, capacityMWp: 11.5, todayMWh: 229, specificYield: 4.31, avgPR: 77.6, avgCUF: 18.5, plantAvailability: 90.1, activePlants: 306, offlinePlants: 34,  activeAlarms: 14 },
  { id: 'MEH-C', name: 'Mehsana Circle',     totalPlants: 420, capacityMWp: 14.4, todayMWh: 283, specificYield: 4.54, avgPR: 78.2, avgCUF: 19.1, plantAvailability: 92.5, activePlants: 389, offlinePlants: 31,  activeAlarms:  5 },
];

// ─── PGVCL Circle centroids (for map dot overlay) ─────────────────────────────
export interface CircleCentroid {
  id: string;
  name: string;
  lat: number;
  lng: number;
  plants: number;
  generationMWh: number;
}

export const pgvclCircleCentroids: CircleCentroid[] = [
  { id: 'AMD-C', name: 'Ahmedabad',   lat: 23.03, lng: 72.59, plants: 920, generationMWh: 1824 },
  { id: 'GND-C', name: 'Gandhinagar', lat: 23.22, lng: 72.68, plants: 640, generationMWh: 1267 },
  { id: 'ANK-C', name: 'Ankleshwar',  lat: 21.63, lng: 73.01, plants: 520, generationMWh: 1031 },
  { id: 'KDA-C', name: 'Kheda',       lat: 22.74, lng: 72.69, plants: 340, generationMWh:  673 },
  { id: 'MEH-C', name: 'Mehsana',     lat: 23.60, lng: 72.39, plants: 420, generationMWh:  830 },
];

// ─── PGVCL Generation Chart (ComposedChart format, GenChartPoint) ─────────────
export const discomGenChart30d: GenChartPoint[] = [
  { date: '29 Mar', actual: 1620, expected: 1720, ghi: 462 },
  { date: '30 Mar', actual: 1680, expected: 1780, ghi: 474 },
  { date: '31 Mar', actual: 1580, expected: 1680, ghi: 448 },
  { date: '01 Apr', actual: 1720, expected: 1820, ghi: 488 },
  { date: '02 Apr', actual: 1760, expected: 1850, ghi: 496 },
  { date: '03 Apr', actual: 1690, expected: 1790, ghi: 478 },
  { date: '04 Apr', actual: 1640, expected: 1740, ghi: 463 },
  { date: '05 Apr', actual: 1780, expected: 1870, ghi: 500 },
  { date: '06 Apr', actual: 1820, expected: 1910, ghi: 510 },
  { date: '07 Apr', actual: 1740, expected: 1830, ghi: 484 },
  { date: '08 Apr', actual: 1660, expected: 1760, ghi: 468 },
  { date: '09 Apr', actual: 1800, expected: 1890, ghi: 506 },
  { date: '10 Apr', actual: 1840, expected: 1930, ghi: 516 },
  { date: '11 Apr', actual: 1750, expected: 1840, ghi: 490 },
  { date: '12 Apr', actual: 1700, expected: 1800, ghi: 480 },
  { date: '13 Apr', actual: 1604, expected: 1710, ghi: 454 },
  { date: '14 Apr', actual: 1718, expected: 1808, ghi: 484 },
  { date: '15 Apr', actual: 1653, expected: 1758, ghi: 467 },
  { date: '16 Apr', actual: 1542, expected: 1646, ghi: 437 },
  { date: '17 Apr', actual: 1810, expected: 1900, ghi: 510 },
  { date: '18 Apr', actual: 1890, expected: 1980, ghi: 532 },
  { date: '19 Apr', actual: 1752, expected: 1842, ghi: 494 },
  { date: '20 Apr', actual: 1688, expected: 1784, ghi: 476 },
  { date: '21 Apr', actual: 1830, expected: 1924, ghi: 516 },
  { date: '22 Apr', actual: 1760, expected: 1856, ghi: 496 },
  { date: '23 Apr', actual: 1695, expected: 1792, ghi: 478 },
  { date: '24 Apr', actual: 1920, expected: 2014, ghi: 542 },
  { date: '25 Apr', actual: 1875, expected: 1970, ghi: 528 },
  { date: '26 Apr', actual: 1840, expected: 1936, ghi: 518 },
  { date: '27 Apr', actual: 1824, expected: 1918, ghi: 514 },
];

export const discomGenChartMonthly: GenChartPoint[] = [
  { date: 'May 25', actual: 52400, expected: 55800, ghi: 498 },
  { date: 'Jun 25', actual: 44200, expected: 47400, ghi: 410 },
  { date: 'Jul 25', actual: 40100, expected: 43200, ghi: 380 },
  { date: 'Aug 25', actual: 41800, expected: 44600, ghi: 393 },
  { date: 'Sep 25', actual: 46200, expected: 49100, ghi: 428 },
  { date: 'Oct 25', actual: 50400, expected: 53500, ghi: 464 },
  { date: 'Nov 25', actual: 49800, expected: 52900, ghi: 460 },
  { date: 'Dec 25', actual: 45200, expected: 48100, ghi: 418 },
  { date: 'Jan 26', actual: 51200, expected: 54400, ghi: 472 },
  { date: 'Feb 26', actual: 53800, expected: 57100, ghi: 492 },
  { date: 'Mar 26', actual: 55200, expected: 58600, ghi: 504 },
  { date: 'Apr 26', actual: 44820, expected: 47600, ghi: 516 },
];

export const discomGenChartHourly: GenChartPoint[] = [
  { date: '6:00',  actual:   12, expected:   14, ghi:  18 },
  { date: '6:30',  actual:   26, expected:   30, ghi:  38 },
  { date: '7:00',  actual:   48, expected:   54, ghi:  68 },
  { date: '7:30',  actual:   72, expected:   80, ghi: 100 },
  { date: '8:00',  actual:   94, expected:  104, ghi: 130 },
  { date: '8:30',  actual:  118, expected:  130, ghi: 162 },
  { date: '9:00',  actual:  136, expected:  150, ghi: 188 },
  { date: '9:30',  actual:  152, expected:  168, ghi: 210 },
  { date: '10:00', actual:  164, expected:  180, ghi: 226 },
  { date: '10:30', actual:  174, expected:  192, ghi: 240 },
  { date: '11:00', actual:  180, expected:  198, ghi: 248 },
  { date: '11:30', actual:  186, expected:  204, ghi: 256 },
  { date: '12:00', actual:  188, expected:  206, ghi: 258 },
  { date: '12:30', actual:  186, expected:  204, ghi: 256 },
  { date: '13:00', actual:  182, expected:  200, ghi: 250 },
  { date: '13:30', actual:  176, expected:  194, ghi: 242 },
  { date: '14:00', actual:  168, expected:  186, ghi: 232 },
  { date: '14:30', actual:  158, expected:  174, ghi: 218 },
  { date: '15:00', actual:  144, expected:  160, ghi: 200 },
  { date: '15:30', actual:  126, expected:  140, ghi: 176 },
  { date: '16:00', actual:  104, expected:  116, ghi: 146 },
  { date: '16:30', actual:   80, expected:   90, ghi: 112 },
  { date: '17:00', actual:   54, expected:   62, ghi:  78 },
  { date: '17:30', actual:   30, expected:   36, ghi:  46 },
  { date: '18:00', actual:   12, expected:   16, ghi:  20 },
];

// ─── PGVCL Top 10 / Bottom 10 Plants ─────────────────────────────────────────
export interface PlantRankRow {
  id: string;
  consumer: string;
  circle: string;
  capacityKWp: number;
  generationKWh: number;
  specificYield: number;
  prPercent: number;
  availPercent: number;
  cufPercent: number;
  status: 'active' | 'offline';
  alarms: number;
}

export const pgvclTop10Plants: PlantRankRow[] = [
  { id: 'GJ-0182', consumer: 'Infosys Ltd',       circle: 'Ahmedabad',   capacityKWp: 500, generationKWh: 2840, specificYield: 5.68, prPercent: 83.2, availPercent: 98.0, cufPercent: 23.7, status: 'active', alarms: 0 },
  { id: 'GJ-0344', consumer: 'Adani Group',        circle: 'Ahmedabad',   capacityKWp: 450, generationKWh: 2610, specificYield: 5.80, prPercent: 82.4, availPercent: 97.6, cufPercent: 24.2, status: 'active', alarms: 0 },
  { id: 'GJ-1022', consumer: 'TCS Gandhinagar',    circle: 'Gandhinagar', capacityKWp: 400, generationKWh: 2380, specificYield: 5.95, prPercent: 81.9, availPercent: 97.4, cufPercent: 24.8, status: 'active', alarms: 0 },
  { id: 'GJ-0781', consumer: 'Sun Pharma',         circle: 'Ankleshwar',  capacityKWp: 380, generationKWh: 2200, specificYield: 5.79, prPercent: 81.4, availPercent: 97.1, cufPercent: 24.1, status: 'active', alarms: 0 },
  { id: 'GJ-0490', consumer: 'GNFC Bharuch',       circle: 'Ankleshwar',  capacityKWp: 350, generationKWh: 2080, specificYield: 5.94, prPercent: 80.8, availPercent: 96.8, cufPercent: 24.8, status: 'active', alarms: 0 },
  { id: 'GJ-0612', consumer: 'Torrent Power',      circle: 'Ahmedabad',   capacityKWp: 320, generationKWh: 1890, specificYield: 5.91, prPercent: 80.2, availPercent: 96.5, cufPercent: 24.6, status: 'active', alarms: 0 },
  { id: 'GJ-0933', consumer: 'Nirma University',   circle: 'Ahmedabad',   capacityKWp: 300, generationKWh: 1755, specificYield: 5.85, prPercent: 79.8, availPercent: 96.2, cufPercent: 24.4, status: 'active', alarms: 0 },
  { id: 'GJ-1140', consumer: 'GSPC LNG',           circle: 'Ankleshwar',  capacityKWp: 280, generationKWh: 1624, specificYield: 5.80, prPercent: 79.4, availPercent: 95.9, cufPercent: 24.2, status: 'active', alarms: 1 },
  { id: 'GJ-0841', consumer: 'Bajaj Auto',         circle: 'Gandhinagar', capacityKWp: 260, generationKWh: 1495, specificYield: 5.75, prPercent: 79.1, availPercent: 95.7, cufPercent: 23.9, status: 'active', alarms: 0 },
  { id: 'GJ-1284', consumer: 'Suzlon Energy',      circle: 'Ahmedabad',   capacityKWp: 250, generationKWh: 1428, specificYield: 5.71, prPercent: 78.8, availPercent: 95.4, cufPercent: 23.8, status: 'active', alarms: 1 },
];

export const pgvclBottom10Plants: PlantRankRow[] = [
  { id: 'GJ-1842', consumer: 'Vinod Mehta',        circle: 'Kheda',       capacityKWp:   6, generationKWh:   21, specificYield: 3.50, prPercent: 46.2, availPercent: 72.4, cufPercent: 14.6, status: 'active', alarms: 3 },
  { id: 'GJ-2201', consumer: 'Ashok Bhatt',         circle: 'Kheda',       capacityKWp:   5, generationKWh:   18, specificYield: 3.60, prPercent: 49.1, availPercent: 74.1, cufPercent: 15.0, status: 'active', alarms: 2 },
  { id: 'GJ-0934', consumer: 'Meena Trivedi',       circle: 'Mehsana',     capacityKWp:   8, generationKWh:   32, specificYield: 4.00, prPercent: 51.4, availPercent: 76.2, cufPercent: 16.7, status: 'active', alarms: 2 },
  { id: 'GJ-1543', consumer: 'Ramesh Amin',         circle: 'Ahmedabad',   capacityKWp:   6, generationKWh:   28, specificYield: 4.67, prPercent: 54.8, availPercent: 77.8, cufPercent: 19.4, status: 'active', alarms: 1 },
  { id: 'GJ-0718', consumer: 'Kavita Shah',         circle: 'Gandhinagar', capacityKWp:  10, generationKWh:   52, specificYield: 5.20, prPercent: 56.3, availPercent: 78.4, cufPercent: 21.7, status: 'active', alarms: 2 },
  { id: 'GJ-2048', consumer: 'Kiran Patel',         circle: 'Kheda',       capacityKWp:   5, generationKWh:   30, specificYield: 6.00, prPercent: 57.1, availPercent: 79.2, cufPercent: 25.0, status: 'offline',alarms: 4 },
  { id: 'GJ-1688', consumer: 'Pushpa Joshi',        circle: 'Mehsana',     capacityKWp:   7, generationKWh:   43, specificYield: 6.14, prPercent: 58.4, availPercent: 79.8, cufPercent: 25.6, status: 'active', alarms: 1 },
  { id: 'GJ-1391', consumer: 'Dinesh Parmar',       circle: 'Kheda',       capacityKWp:   8, generationKWh:   52, specificYield: 6.50, prPercent: 59.2, availPercent: 80.1, cufPercent: 27.1, status: 'active', alarms: 2 },
  { id: 'GJ-2302', consumer: 'Nalini Desai',        circle: 'Ahmedabad',   capacityKWp:   6, generationKWh:   39, specificYield: 6.50, prPercent: 60.1, availPercent: 80.4, cufPercent: 27.1, status: 'active', alarms: 1 },
  { id: 'GJ-1721', consumer: 'Mahesh Solanki',      circle: 'Ankleshwar',  capacityKWp:  10, generationKWh:   66, specificYield: 6.60, prPercent: 61.8, availPercent: 81.2, cufPercent: 27.5, status: 'active', alarms: 2 },
];

// ─── PGVCL Sub-Division Monitoring ───────────────────────────────────────────
export interface SubDivisionMonitoringRow {
  subDivision: string;
  circle: string;
  division: string;
  dataTxPercent: number;
  plantsOffline: number;
  activeAlarms: number;
  certsExpiring: number;
  firmwareOutdated: number;
}

export const pgvclSubDivMonitoring: SubDivisionMonitoringRow[] = [
  // Ahmedabad — North
  { subDivision: 'Satellite Road', circle: 'Ahmedabad', division: 'North',   dataTxPercent: 98.4, plantsOffline:  6, activeAlarms:  4, certsExpiring: 1, firmwareOutdated: 2 },
  { subDivision: 'Bopal',          circle: 'Ahmedabad', division: 'North',   dataTxPercent: 97.8, plantsOffline:  7, activeAlarms:  3, certsExpiring: 0, firmwareOutdated: 2 },
  { subDivision: 'Chandkheda',     circle: 'Ahmedabad', division: 'North',   dataTxPercent: 97.1, plantsOffline:  8, activeAlarms:  5, certsExpiring: 1, firmwareOutdated: 3 },
  // Ahmedabad — Central
  { subDivision: 'Maninagar',      circle: 'Ahmedabad', division: 'Central', dataTxPercent: 98.6, plantsOffline:  5, activeAlarms:  2, certsExpiring: 0, firmwareOutdated: 1 },
  { subDivision: 'Narol',          circle: 'Ahmedabad', division: 'Central', dataTxPercent: 97.4, plantsOffline:  6, activeAlarms:  3, certsExpiring: 1, firmwareOutdated: 2 },
  { subDivision: 'Vatva',          circle: 'Ahmedabad', division: 'Central', dataTxPercent: 96.2, plantsOffline: 11, activeAlarms:  8, certsExpiring: 1, firmwareOutdated: 3 },
  // Ahmedabad — South
  { subDivision: 'Sarkhej',        circle: 'Ahmedabad', division: 'South',   dataTxPercent: 97.9, plantsOffline:  6, activeAlarms:  3, certsExpiring: 0, firmwareOutdated: 2 },
  { subDivision: 'Sanand',         circle: 'Ahmedabad', division: 'South',   dataTxPercent: 96.8, plantsOffline:  8, activeAlarms:  6, certsExpiring: 1, firmwareOutdated: 3 },
  { subDivision: 'Bavla',          circle: 'Ahmedabad', division: 'South',   dataTxPercent: 94.1, plantsOffline: 15, activeAlarms: 12, certsExpiring: 2, firmwareOutdated: 5 },
  // Gandhinagar — East
  { subDivision: 'Sector 8',       circle: 'Gandhinagar', division: 'East',  dataTxPercent: 98.2, plantsOffline:  6, activeAlarms:  2, certsExpiring: 0, firmwareOutdated: 1 },
  { subDivision: 'Sector 15',      circle: 'Gandhinagar', division: 'East',  dataTxPercent: 97.6, plantsOffline:  7, activeAlarms:  3, certsExpiring: 1, firmwareOutdated: 2 },
  { subDivision: 'Mansa',          circle: 'Gandhinagar', division: 'East',  dataTxPercent: 96.9, plantsOffline:  9, activeAlarms:  4, certsExpiring: 0, firmwareOutdated: 2 },
  // Gandhinagar — West
  { subDivision: 'Kalol',          circle: 'Gandhinagar', division: 'West',  dataTxPercent: 97.2, plantsOffline:  9, activeAlarms:  5, certsExpiring: 1, firmwareOutdated: 2 },
  { subDivision: 'Dehgam',         circle: 'Gandhinagar', division: 'West',  dataTxPercent: 95.8, plantsOffline: 12, activeAlarms:  7, certsExpiring: 1, firmwareOutdated: 3 },
  { subDivision: 'Vijapur',        circle: 'Gandhinagar', division: 'West',  dataTxPercent: 94.4, plantsOffline: 16, activeAlarms: 10, certsExpiring: 1, firmwareOutdated: 4 },
  // Ankleshwar — East
  { subDivision: 'GIDC Phase 1',   circle: 'Ankleshwar', division: 'East',   dataTxPercent: 98.8, plantsOffline:  5, activeAlarms:  1, certsExpiring: 0, firmwareOutdated: 1 },
  { subDivision: 'GIDC Phase 2',   circle: 'Ankleshwar', division: 'East',   dataTxPercent: 97.9, plantsOffline:  9, activeAlarms:  3, certsExpiring: 0, firmwareOutdated: 2 },
  // Ankleshwar — West
  { subDivision: 'Zadeshwar',      circle: 'Ankleshwar', division: 'West',   dataTxPercent: 98.1, plantsOffline:  7, activeAlarms:  2, certsExpiring: 0, firmwareOutdated: 1 },
  { subDivision: 'Amod',           circle: 'Ankleshwar', division: 'West',   dataTxPercent: 95.6, plantsOffline: 10, activeAlarms:  9, certsExpiring: 1, firmwareOutdated: 3 },
  // Kheda — North
  { subDivision: 'Nadiad',         circle: 'Kheda', division: 'North',       dataTxPercent: 96.4, plantsOffline:  8, activeAlarms:  4, certsExpiring: 1, firmwareOutdated: 2 },
  { subDivision: 'Anand',          circle: 'Kheda', division: 'North',       dataTxPercent: 95.1, plantsOffline: 11, activeAlarms:  7, certsExpiring: 1, firmwareOutdated: 3 },
  // Kheda — South
  { subDivision: 'Petlad',         circle: 'Kheda', division: 'South',       dataTxPercent: 95.8, plantsOffline:  9, activeAlarms:  5, certsExpiring: 0, firmwareOutdated: 2 },
  { subDivision: 'Khambhat',       circle: 'Kheda', division: 'South',       dataTxPercent: 91.2, plantsOffline: 11, activeAlarms: 14, certsExpiring: 2, firmwareOutdated: 5 },
  // Mehsana — North
  { subDivision: 'Mehsana City',   circle: 'Mehsana', division: 'North',     dataTxPercent: 97.4, plantsOffline:  6, activeAlarms:  2, certsExpiring: 0, firmwareOutdated: 1 },
  { subDivision: 'Kadi',           circle: 'Mehsana', division: 'North',     dataTxPercent: 96.8, plantsOffline:  8, activeAlarms:  3, certsExpiring: 0, firmwareOutdated: 2 },
  // Mehsana — South
  { subDivision: 'Visnagar',       circle: 'Mehsana', division: 'South',     dataTxPercent: 96.1, plantsOffline:  8, activeAlarms:  3, certsExpiring: 1, firmwareOutdated: 2 },
  { subDivision: 'Unjha',          circle: 'Mehsana', division: 'South',     dataTxPercent: 93.8, plantsOffline: 15, activeAlarms: 11, certsExpiring: 1, firmwareOutdated: 4 },
];

// ─── PGVCL Division Monitoring ────────────────────────────────────────────────
export interface DivisionMonitoringRow {
  division: string;
  circle: string;
  dataTxPercent: number;
  plantsOffline: number;
  activeAlarms: number;
  certsExpiring: number;
  firmwareOutdated: number;
}

export const pgvclDivMonitoring: DivisionMonitoringRow[] = [
  { division: 'North',   circle: 'Ahmedabad',   dataTxPercent: 97.8, plantsOffline: 21, activeAlarms: 12, certsExpiring: 2, firmwareOutdated: 7 },
  { division: 'Central', circle: 'Ahmedabad',   dataTxPercent: 97.4, plantsOffline: 22, activeAlarms: 13, certsExpiring: 2, firmwareOutdated: 6 },
  { division: 'South',   circle: 'Ahmedabad',   dataTxPercent: 96.3, plantsOffline: 29, activeAlarms: 21, certsExpiring: 3, firmwareOutdated: 10 },
  { division: 'East',    circle: 'Gandhinagar', dataTxPercent: 97.6, plantsOffline: 22, activeAlarms:  9, certsExpiring: 1, firmwareOutdated: 5 },
  { division: 'West',    circle: 'Gandhinagar', dataTxPercent: 95.8, plantsOffline: 37, activeAlarms: 22, certsExpiring: 3, firmwareOutdated: 9 },
  { division: 'East',    circle: 'Ankleshwar',  dataTxPercent: 98.4, plantsOffline: 14, activeAlarms:  4, certsExpiring: 0, firmwareOutdated: 3 },
  { division: 'West',    circle: 'Ankleshwar',  dataTxPercent: 96.8, plantsOffline: 17, activeAlarms: 11, certsExpiring: 1, firmwareOutdated: 4 },
  { division: 'North',   circle: 'Kheda',       dataTxPercent: 95.8, plantsOffline: 19, activeAlarms: 11, certsExpiring: 2, firmwareOutdated: 5 },
  { division: 'South',   circle: 'Kheda',       dataTxPercent: 93.5, plantsOffline: 20, activeAlarms: 19, certsExpiring: 2, firmwareOutdated: 7 },
  { division: 'North',   circle: 'Mehsana',     dataTxPercent: 97.1, plantsOffline: 14, activeAlarms:  5, certsExpiring: 0, firmwareOutdated: 3 },
  { division: 'South',   circle: 'Mehsana',     dataTxPercent: 94.9, plantsOffline: 23, activeAlarms: 14, certsExpiring: 2, firmwareOutdated: 6 },
];

// ─── Vendor Overview Panel ─────────────────────────────────────────────────────
export const vendorPortfolioPanel = {
  totalPlants: 342,
  capacity: '18.4 MWp',
  todayGeneration: '3,096 MWh',
  specificYield: 3.42,
  avgPR: 78.4,
  avgCUF: 18.9,
  plantAvailability: 94.7,
  activePlants: 324,
  offlinePlants: 18,
  activeAlarms: 27,
};

export interface VendorStatePanelData {
  name: string;
  totalPlants: number;
  capacity: string;
  todayGeneration: string;
  specificYield: number;
  avgPR: number;
  avgCUF: number;
  plantAvailability: number;
  activePlants: number;
  offlinePlants: number;
  activeAlarms: number;
}

export const vendorStatePanels: VendorStatePanelData[] = [
  { name: 'Gujarat',     totalPlants: 142, capacity: '7.8 MWp',  todayGeneration: '1,284 MWh', specificYield: 3.51, avgPR: 79.2, avgCUF: 19.4, plantAvailability: 95.8, activePlants: 137, offlinePlants: 5,  activeAlarms: 9  },
  { name: 'Rajasthan',   totalPlants: 58,  capacity: '3.2 MWp',  todayGeneration: '546 MWh',   specificYield: 3.58, avgPR: 80.1, avgCUF: 20.8, plantAvailability: 96.6, activePlants: 56,  offlinePlants: 2,  activeAlarms: 3  },
  { name: 'Maharashtra', totalPlants: 42,  capacity: '2.2 MWp',  todayGeneration: '374 MWh',   specificYield: 3.31, avgPR: 76.8, avgCUF: 17.9, plantAvailability: 92.9, activePlants: 38,  offlinePlants: 4,  activeAlarms: 5  },
  { name: 'Karnataka',   totalPlants: 24,  capacity: '1.1 MWp',  todayGeneration: '244 MWh',   specificYield: 3.42, avgPR: 78.5, avgCUF: 18.5, plantAvailability: 95.8, activePlants: 22,  offlinePlants: 2,  activeAlarms: 2  },
  { name: 'Tamil Nadu',  totalPlants: 76,  capacity: '4.1 MWp',  todayGeneration: '648 MWh',   specificYield: 3.38, avgPR: 77.4, avgCUF: 18.2, plantAvailability: 93.4, activePlants: 71,  offlinePlants: 5,  activeAlarms: 8  },
];

// ─── Vendor Generation — Combo chart data ─────────────────────────────────────
export const vendorGenChart30d: GenChartPoint[] = [
  { date: '29 Mar', actual: 2812, expected: 3100, ghi: 448 },
  { date: '30 Mar', actual: 2940, expected: 3180, ghi: 462 },
  { date: '31 Mar', actual: 2784, expected: 3050, ghi: 442 },
  { date: '1 Apr',  actual: 2645, expected: 2920, ghi: 424 },
  { date: '2 Apr',  actual: 3018, expected: 3240, ghi: 470 },
  { date: '3 Apr',  actual: 3142, expected: 3380, ghi: 490 },
  { date: '4 Apr',  actual: 2960, expected: 3180, ghi: 461 },
  { date: '5 Apr',  actual: 2876, expected: 3120, ghi: 453 },
  { date: '6 Apr',  actual: 3080, expected: 3310, ghi: 480 },
  { date: '7 Apr',  actual: 2982, expected: 3220, ghi: 467 },
  { date: '8 Apr',  actual: 2845, expected: 3090, ghi: 448 },
  { date: '9 Apr',  actual: 3210, expected: 3440, ghi: 499 },
  { date: '10 Apr', actual: 3180, expected: 3400, ghi: 494 },
  { date: '11 Apr', actual: 3124, expected: 3360, ghi: 487 },
  { date: '12 Apr', actual: 2948, expected: 3180, ghi: 461 },
  { date: '13 Apr', actual: 3062, expected: 3290, ghi: 477 },
  { date: '14 Apr', actual: 3188, expected: 3420, ghi: 496 },
  { date: '15 Apr', actual: 2922, expected: 3150, ghi: 457 },
  { date: '16 Apr', actual: 3048, expected: 3280, ghi: 476 },
  { date: '17 Apr', actual: 3284, expected: 3510, ghi: 509 },
  { date: '18 Apr', actual: 3142, expected: 3380, ghi: 490 },
  { date: '19 Apr', actual: 2986, expected: 3220, ghi: 467 },
  { date: '20 Apr', actual: 3318, expected: 3550, ghi: 515 },
  { date: '21 Apr', actual: 3204, expected: 3440, ghi: 499 },
  { date: '22 Apr', actual: 3412, expected: 3660, ghi: 531 },
  { date: '23 Apr', actual: 3284, expected: 3510, ghi: 509 },
  { date: '24 Apr', actual: 3096, expected: 3330, ghi: 483 },
  { date: '25 Apr', actual: 3448, expected: 3680, ghi: 534 },
  { date: '26 Apr', actual: 3380, expected: 3600, ghi: 522 },
  { date: '27 Apr', actual: 3124, expected: 3360, ghi: 487 },
  { date: '28 Apr', actual: 3096, expected: 3330, ghi: 483 },
];

export const vendorGenChartMonthly: GenChartPoint[] = [
  { date: 'Sep',  actual: 68400, expected: 73200, ghi: 412 },
  { date: 'Oct',  actual: 72800, expected: 78100, ghi: 439 },
  { date: 'Nov',  actual: 69200, expected: 74500, ghi: 419 },
  { date: 'Dec',  actual: 62400, expected: 67800, ghi: 382 },
  { date: 'Jan',  actual: 65800, expected: 71200, ghi: 401 },
  { date: 'Feb',  actual: 71200, expected: 76600, ghi: 432 },
  { date: 'Mar',  actual: 79600, expected: 84800, ghi: 478 },
  { date: 'Apr',  actual: 82400, expected: 88200, ghi: 497 },
];

export const vendorGenChartHourly: GenChartPoint[] = [
  { date: '06:00', actual: 0,    expected: 0,    ghi: 0   },
  { date: '06:30', actual: 48,   expected: 52,   ghi: 28  },
  { date: '07:00', actual: 184,  expected: 198,  ghi: 106 },
  { date: '07:30', actual: 342,  expected: 368,  ghi: 196 },
  { date: '08:00', actual: 528,  expected: 568,  ghi: 302 },
  { date: '08:30', actual: 712,  expected: 766,  ghi: 408 },
  { date: '09:00', actual: 892,  expected: 958,  ghi: 510 },
  { date: '09:30', actual: 1048, expected: 1124, ghi: 599 },
  { date: '10:00', actual: 1184, expected: 1268, ghi: 676 },
  { date: '10:30', actual: 1298, expected: 1388, ghi: 740 },
  { date: '11:00', actual: 1382, expected: 1476, ghi: 788 },
  { date: '11:30', actual: 1448, expected: 1548, ghi: 826 },
  { date: '12:00', actual: 1492, expected: 1596, ghi: 851 },
  { date: '12:30', actual: 1484, expected: 1590, ghi: 848 },
  { date: '13:00', actual: 1462, expected: 1566, ghi: 836 },
  { date: '13:30', actual: 1418, expected: 1520, ghi: 812 },
  { date: '14:00', actual: 1352, expected: 1448, ghi: 774 },
  { date: '14:30', actual: 1268, expected: 1358, ghi: 726 },
  { date: '15:00', actual: 1148, expected: 1230, ghi: 657 },
  { date: '15:30', actual: 1008, expected: 1082, ghi: 578 },
  { date: '16:00', actual: 848,  expected: 912,  ghi: 487 },
  { date: '16:30', actual: 668,  expected: 720,  ghi: 384 },
  { date: '17:00', actual: 482,  expected: 520,  ghi: 278 },
  { date: '17:30', actual: 284,  expected: 308,  ghi: 165 },
  { date: '18:00', actual: 98,   expected: 108,  ghi: 58  },
  { date: '18:30', actual: 8,    expected: 10,   ghi: 4   },
];

// ─── Vendor Generation — Top 10 / Bottom 10 ──────────────────────────────────
export interface VendorPlantRankRow {
  id: string;
  consumer: string;
  state: string;
  capacityKWp: number;
  generationKWh: number;
  specificYield: number;
  prPercent: number;
  availPercent: number;
  cufPercent: number;
  status: 'active' | 'offline';
  alarms: number;
}

export const vendorTop10Plants: VendorPlantRankRow[] = [
  { id: 'GJ-0182', consumer: 'Infosys Ltd',       state: 'Gujarat',     capacityKWp: 500, generationKWh: 2840, specificYield: 5.68, prPercent: 83.2, availPercent: 98.4, cufPercent: 23.7, status: 'active',  alarms: 0 },
  { id: 'RJ-0441', consumer: 'Rajasthan Petro',    state: 'Rajasthan',   capacityKWp: 480, generationKWh: 2720, specificYield: 5.67, prPercent: 82.8, availPercent: 97.9, cufPercent: 23.6, status: 'active',  alarms: 0 },
  { id: 'GJ-0344', consumer: 'Adani Group',        state: 'Gujarat',     capacityKWp: 450, generationKWh: 2610, specificYield: 5.80, prPercent: 81.9, availPercent: 99.1, cufPercent: 24.2, status: 'active',  alarms: 0 },
  { id: 'MH-1102', consumer: 'Mahindra Nashik',    state: 'Maharashtra', capacityKWp: 420, generationKWh: 2450, specificYield: 5.83, prPercent: 82.1, availPercent: 98.2, cufPercent: 24.3, status: 'active',  alarms: 0 },
  { id: 'KA-0288', consumer: 'Wipro Bengaluru',    state: 'Karnataka',   capacityKWp: 400, generationKWh: 2240, specificYield: 5.60, prPercent: 81.4, availPercent: 97.6, cufPercent: 23.3, status: 'active',  alarms: 1 },
  { id: 'GJ-0891', consumer: 'Torrent Power',      state: 'Gujarat',     capacityKWp: 380, generationKWh: 2148, specificYield: 5.65, prPercent: 80.8, availPercent: 97.4, cufPercent: 23.5, status: 'active',  alarms: 0 },
  { id: 'TN-0156', consumer: 'TVS Motors',         state: 'Tamil Nadu',  capacityKWp: 360, generationKWh: 2024, specificYield: 5.62, prPercent: 80.4, availPercent: 97.2, cufPercent: 23.4, status: 'active',  alarms: 0 },
  { id: 'RJ-0328', consumer: 'RVNL Jaipur',        state: 'Rajasthan',   capacityKWp: 350, generationKWh: 1988, specificYield: 5.68, prPercent: 80.2, availPercent: 96.8, cufPercent: 23.7, status: 'active',  alarms: 0 },
  { id: 'GJ-1024', consumer: 'Parekh Pvt Ltd',     state: 'Gujarat',     capacityKWp: 340, generationKWh: 1920, specificYield: 5.65, prPercent: 79.8, availPercent: 96.5, cufPercent: 23.5, status: 'active',  alarms: 2 },
  { id: 'MH-0642', consumer: 'Bajaj Auto',         state: 'Maharashtra', capacityKWp: 320, generationKWh: 1804, specificYield: 5.64, prPercent: 79.6, availPercent: 96.2, cufPercent: 23.5, status: 'active',  alarms: 0 },
];

export const vendorBottom10Plants: VendorPlantRankRow[] = [
  { id: 'GJ-1842', consumer: 'Vinod Mehta',     state: 'Gujarat',     capacityKWp: 6,  generationKWh: 21,  specificYield: 3.50, prPercent: 46.2, availPercent: 72.4, cufPercent: 14.6, status: 'active',  alarms: 3 },
  { id: 'MH-0812', consumer: 'Datta Jadhav',    state: 'Maharashtra', capacityKWp: 5,  generationKWh: 18,  specificYield: 3.60, prPercent: 48.9, availPercent: 75.8, cufPercent: 15.0, status: 'active',  alarms: 2 },
  { id: 'GJ-2201', consumer: 'Ashok Bhatt',     state: 'Gujarat',     capacityKWp: 5,  generationKWh: 18,  specificYield: 3.60, prPercent: 49.1, availPercent: 76.2, cufPercent: 15.0, status: 'offline', alarms: 4 },
  { id: 'GJ-0934', consumer: 'Meena Trivedi',   state: 'Gujarat',     capacityKWp: 8,  generationKWh: 32,  specificYield: 4.00, prPercent: 51.4, availPercent: 78.4, cufPercent: 16.7, status: 'offline', alarms: 2 },
  { id: 'RJ-1204', consumer: 'Hanuman Farms',   state: 'Rajasthan',   capacityKWp: 10, generationKWh: 44,  specificYield: 4.40, prPercent: 51.8, availPercent: 79.6, cufPercent: 18.3, status: 'active',  alarms: 1 },
  { id: 'TN-0884', consumer: 'Sekhar V',        state: 'Tamil Nadu',  capacityKWp: 6,  generationKWh: 26,  specificYield: 4.33, prPercent: 52.4, availPercent: 80.2, cufPercent: 18.1, status: 'active',  alarms: 1 },
  { id: 'MH-1448', consumer: 'Nilesh Patil',    state: 'Maharashtra', capacityKWp: 8,  generationKWh: 36,  specificYield: 4.50, prPercent: 53.8, availPercent: 81.4, cufPercent: 18.8, status: 'active',  alarms: 2 },
  { id: 'GJ-1682', consumer: 'Jagdish Rao',     state: 'Gujarat',     capacityKWp: 10, generationKWh: 46,  specificYield: 4.60, prPercent: 54.2, availPercent: 82.0, cufPercent: 19.2, status: 'active',  alarms: 0 },
  { id: 'KA-0814', consumer: 'Rajan Shetty',    state: 'Karnataka',   capacityKWp: 8,  generationKWh: 38,  specificYield: 4.75, prPercent: 55.1, availPercent: 83.1, cufPercent: 19.8, status: 'active',  alarms: 1 },
  { id: 'RJ-0982', consumer: 'Bholu Singh',     state: 'Rajasthan',   capacityKWp: 6,  generationKWh: 30,  specificYield: 5.00, prPercent: 55.4, availPercent: 84.2, cufPercent: 20.8, status: 'active',  alarms: 0 },
];

// ─── Vendor Fleet Health ────────────────────────────────────────────────────────
export const vendorFleetTileCounts = {
  activeAlarms:      27,
  criticalAlarms:     4,
  plantsOffline:     18,
  rmsOffline:         6,
  firmwareOutdated:  23,
  certsExpiring:      8,
  certsExpired:       3,
};

export interface VendorFleetDevice {
  imei: string;
  plantId: string;
  consumer: string;
  state: string;
  plantStatus: 'Online' | 'Offline' | 'Fault';
  rmsStatus: 'Connected' | 'Disconnected';
  firmwareVersion: string;
  certExpiry: string;
  daysRemaining: number;
  lastSeen: string;
  alarms: number;
  firmwareOutdated: boolean;
}

export const vendorFleetDevices: VendorFleetDevice[] = [
  { imei: '354678901234567', plantId: 'GJ-0482', consumer: 'Amitbhai Patel',  state: 'Gujarat',     plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.4.1', certExpiry: '2026-05-15', daysRemaining:  17, lastSeen: '2m ago',   alarms: 2, firmwareOutdated: false },
  { imei: '354678901234568', plantId: 'GJ-1024', consumer: 'Parekh Pvt Ltd',  state: 'Gujarat',     plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.3.8', certExpiry: '2026-06-30', daysRemaining:  63, lastSeen: '5m ago',   alarms: 0, firmwareOutdated: true  },
  { imei: '354678901234569', plantId: 'RJ-2201', consumer: 'Hanuman Farms',   state: 'Rajasthan',   plantStatus: 'Offline', rmsStatus: 'Disconnected', firmwareVersion: '2.2.1', certExpiry: '2026-04-10', daysRemaining: -18, lastSeen: '26h ago',  alarms: 3, firmwareOutdated: true  },
  { imei: '354678901234570', plantId: 'TN-0312', consumer: 'TVS Motors',      state: 'Tamil Nadu',  plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.4.1', certExpiry: '2026-12-01', daysRemaining: 217, lastSeen: '3m ago',   alarms: 0, firmwareOutdated: false },
  { imei: '354678901234571', plantId: 'MH-1102', consumer: 'Mahindra Nashik', state: 'Maharashtra', plantStatus: 'Fault',   rmsStatus: 'Connected',    firmwareVersion: '2.1.4', certExpiry: '2026-05-08', daysRemaining:  10, lastSeen: '18m ago',  alarms: 1, firmwareOutdated: true  },
  { imei: '354678901234572', plantId: 'GJ-0182', consumer: 'Infosys Ltd',     state: 'Gujarat',     plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.4.1', certExpiry: '2027-01-15', daysRemaining: 262, lastSeen: '1m ago',   alarms: 0, firmwareOutdated: false },
  { imei: '354678901234573', plantId: 'GJ-0344', consumer: 'Adani Group',     state: 'Gujarat',     plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.4.0', certExpiry: '2026-05-22', daysRemaining:  24, lastSeen: '4m ago',   alarms: 0, firmwareOutdated: true  },
  { imei: '354678901234574', plantId: 'KA-0288', consumer: 'Wipro Bengaluru', state: 'Karnataka',   plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.4.1', certExpiry: '2026-08-10', daysRemaining: 104, lastSeen: '6m ago',   alarms: 1, firmwareOutdated: false },
  { imei: '354678901234575', plantId: 'GJ-1842', consumer: 'Vinod Mehta',     state: 'Gujarat',     plantStatus: 'Offline', rmsStatus: 'Disconnected', firmwareVersion: '2.2.4', certExpiry: '2026-04-20', daysRemaining:  -8, lastSeen: '4d ago',   alarms: 3, firmwareOutdated: true  },
  { imei: '354678901234576', plantId: 'TN-0156', consumer: 'TVS Motors',      state: 'Tamil Nadu',  plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.4.1', certExpiry: '2026-11-15', daysRemaining: 201, lastSeen: '2m ago',   alarms: 0, firmwareOutdated: false },
  { imei: '354678901234577', plantId: 'RJ-0441', consumer: 'Rajasthan Petro', state: 'Rajasthan',   plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.3.5', certExpiry: '2026-07-20', daysRemaining:  83, lastSeen: '8m ago',   alarms: 0, firmwareOutdated: true  },
  { imei: '354678901234578', plantId: 'MH-0812', consumer: 'Datta Jadhav',    state: 'Maharashtra', plantStatus: 'Offline', rmsStatus: 'Disconnected', firmwareVersion: '2.1.8', certExpiry: '2026-05-28', daysRemaining:  30, lastSeen: '2d ago',   alarms: 2, firmwareOutdated: true  },
  { imei: '354678901234579', plantId: 'GJ-2201', consumer: 'Ashok Bhatt',     state: 'Gujarat',     plantStatus: 'Offline', rmsStatus: 'Disconnected', firmwareVersion: '2.3.1', certExpiry: '2026-06-14', daysRemaining:  47, lastSeen: '3d ago',   alarms: 4, firmwareOutdated: true  },
  { imei: '354678901234580', plantId: 'GJ-0891', consumer: 'Torrent Power',   state: 'Gujarat',     plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.4.1', certExpiry: '2026-10-08', daysRemaining: 163, lastSeen: '1m ago',   alarms: 0, firmwareOutdated: false },
  { imei: '354678901234581', plantId: 'KA-0814', consumer: 'Rajan Shetty',    state: 'Karnataka',   plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.4.0', certExpiry: '2026-05-18', daysRemaining:  20, lastSeen: '12m ago',  alarms: 1, firmwareOutdated: true  },
  { imei: '354678901234582', plantId: 'TN-0884', consumer: 'Sekhar V',        state: 'Tamil Nadu',  plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.2.8', certExpiry: '2026-09-22', daysRemaining: 147, lastSeen: '7m ago',   alarms: 1, firmwareOutdated: true  },
  { imei: '354678901234583', plantId: 'RJ-0328', consumer: 'RVNL Jaipur',     state: 'Rajasthan',   plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.4.1', certExpiry: '2027-02-28', daysRemaining: 306, lastSeen: '3m ago',   alarms: 0, firmwareOutdated: false },
  { imei: '354678901234584', plantId: 'MH-0642', consumer: 'Bajaj Auto',      state: 'Maharashtra', plantStatus: 'Online',  rmsStatus: 'Connected',    firmwareVersion: '2.4.1', certExpiry: '2026-12-15', daysRemaining: 231, lastSeen: '5m ago',   alarms: 0, firmwareOutdated: false },
];
